console.log("init Proteus treatments -- 2.02")

window.dataLayer = window.dataLayer || [];

// upsells tracking
observeSelector('.cart-upsell__add', upsell_atc => {
  upsell_atc.addEventListener("click", () => {

    let upsell_main_product = upsell_atc.closest('form').querySelector('input[name="properties[_bundled_with]"]');
    let upsell_product = upsell_atc.closest('form').querySelector('input[name="id"]');
    if(upsell_product && upsell_main_product){
      dataLayer.push({
        event: "proteus_custom_event",
        proteus_event_name: `upsell: ${upsell_product.value} -- _bundled_with: ${upsell_main_product.value}`,
        proteus_event_category: "CRO",
        page_location: location.href
      });
    }
    
  })
})

// attentive popup event tracking -- v1.1
window.addEventListener("message", function (e) {

  const a = e?.data?.__attentive;

  if (!a || !a.creativeId || !a.action) return;
  console.log("ATTENTIVE MESSAGE:", e.data);
  
  dataLayer.push({
    event: "proteus_custom_event",
    proteus_event_name: `ATTN ${a.creativeId} -- ${a.action}`,
    proteus_event_category: "CRO",
    page_location: location.href
  });
});

// START [CHRP-16] price test
window.activate_chirp_16v1 = () => {
  console.log("init [CHRP-16]v1")

  window.sessionStorage.setItem("[CHRP-16]v1", "active")
  const new_var_id = 44464509485079;
  const new_price = "$549.99";
  const new_bundle_price = "$609.98";
  const og_var_id = 41863386890263;
  const og_price = "$599.99";
  const og_bundle_price = "$659.98";

  observeSelector(`input[name="id"][value="${og_var_id}"]`, input => {
    input.value = new_var_id;
    console.log('updated input', input)
  })

  // HP + collections
  observeSelector('.b-product-card strong', card_text => {
    if(card_text.innerText == og_price){
      card_text.innerText = new_price;
      console.log('updated card_text', card_text)
    }
  })

  // PDP 
  observeSelector('#chirpProductPrice', pdp_price => {
    if(window.location.href.indexOf('/products/chirp-contour-decompression-and-massage-bed') > -1){
      setInterval(() => {
        let price_label = pdp_price.querySelector('strong');
        if(price_label.innerText == og_bundle_price){
          price_label.innerText = new_bundle_price
        } else if(price_label.innerText == og_price){
          price_label.innerText = new_price
        } 
      }, 10)
    }
  })
};
if(window.location.href.indexOf("price-test") > -1 || window.sessionStorage.getItem("[CHRP-16]v1")){
  window.activate_chirp_16v1();
}
// END [CHRP-16] price test

// support for proteus pp_offers
if(window.location.href.indexOf("qa=pp") > -1){
  window.sessionStorage.setItem("Proteus PP QA", true);
}

const push_pp_offers = () => {
    if(window.sessionStorage.getItem("Proteus pp-session-id") && window.cart_pp_offers.length > 0){

        console.log("push_pp_offers()");

        let session_id = window.sessionStorage.getItem("Proteus pp-session-id");
        fetch("https://proteus-chirp.fly.dev/api/pp_offers", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            referenceId: session_id,
            offers: window.cart_pp_offers
        })
        }).then(res => res.json()).then(console.log).catch(console.error);

    }
};

setTimeout(() => {
  if(!window.sessionStorage.getItem("Proteus pp-session-id")){ // && window.sessionStorage.getItem("Proteus PP QA")
    let pp_session_id = "pp-";
    for (let i = 0; i < 16; i++) {
      pp_session_id += Math.floor(Math.random() * 10);
    }
    window.sessionStorage.setItem("Proteus pp-session-id", pp_session_id)
    setTimeout(() => {
      gtm_add_cartAttribute("pp-session-id", pp_session_id);
    }, 2500); // delay to reduce API clogging
  }

  push_pp_offers();

}, 500); // delay to reduce API clogging

async function update_cart_data() {
  try {
    const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
    if (!res.ok) throw new Error("Failed to fetch cart");
    const cart = await res.json();

    window.cart_data = cart;
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", { 
        detail: { cart },
        bubbles: true
      })
    );

    return cart;
  } catch (err) {
    console.error("Error fetching cart:", err);
    return null;
  }
}

async function get_proteus_product_data(prod_id) {
  console.log("get_proteus_product_data()");
  // could potentially do this via Shopify REST API
  const response = await fetch(`https://proteus-chirp.fly.dev/api/catalog?lookup=product_alt&id=${prod_id}`);

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const data = await response.json();
  return data;
}

window.cart_css_selector = "turbo-frame#frame-main-cart";
waitForElement(window.cart_css_selector).then(cart => {

  let current_state = cart.innerText.toLowerCase();
  setInterval(() => {
    if(document.querySelector(window.cart_css_selector).innerText.toLowerCase() != current_state){
      console.log("cart updated -- get data");
      update_cart_data();
      // set new current state
      current_state = document.querySelector(window.cart_css_selector).innerText.toLowerCase();
    }
  }, 2000); // 2s

}).catch();

document.addEventListener("cart:change", (e) => {
  console.log("cart change", e.detail.cart);

  // review cart for PP offers if there aren't already a few defined
  if(window.cart_pp_offers.length < 3){

    for(let i = 0; i < window.cart_data.items.length; i++){
      
      console.log("reviewing", window.cart_data.items[i].title)

      if(!window.cart_pp_offers.some(obj => obj.pp_offer_id == window.cart_data.items[i].variant_id)){

        // if THIS product doesn't already have its pp_offer_id added
        get_proteus_product_data(window.cart_data.items[i].product_id).then(prod_data => {
          
          let pp_offer = prod_data.metafields.find(obj => obj.key === "post_purchase_offer_1");
          if(pp_offer){

            let ref_id = pp_offer.reference.id;
            let offer_obj = prod_data.metaobjects.find(obj => obj.id === ref_id);
            
            console.log("looking at pp offer", prod_data.product.title, offer_obj.handle)

            let offer_type = offer_obj.fields.offer_type;
            let banner_title = offer_obj.fields.title;
            let offer_title = offer_obj.fields.offer_title;
            let offer_description = offer_obj.fields.description;
            let products = offer_obj.fields.product;
            let image_overrides = offer_obj.fields.image_overrides;
            let discount_percent = offer_obj.fields.discount_percent;
            let offer_duplicates = offer_obj.fields.offer_duplicates;

            let discount_multiplier = (100 - discount_percent)/100;
            
            let offer_product_titles = "";
            let offer_product_images = [];

            let offer_product_var_ids = [];
            let offer_price = 0;
            let offer_compare_at = 0;
            let pp_changes = [];

            for(let i = 0; i < products.length; i++){

              offer_product_titles += `${products[i].title} `;
              offer_product_images.push(products[i].featuredImage.url);

              let pp_var_id = parseInt(products[i].variants.edges[0].node.id.split("/").pop());
              let pp_var_price = parseFloat(products[i].variants.edges[0].node.price);
              let pp_var_compare_at = parseFloat(products[i].variants.edges[0].node.compareAtPrice);
              
              offer_product_var_ids.push(pp_var_id);
              offer_price += pp_var_price;
              offer_compare_at += pp_var_compare_at;

              pp_changes.push({
                "type": "add_variant",
                "variantId": pp_var_id,
                "quantity": 1,
                ...(discount_percent > 0 && {
                  "discount": {
                    "value": discount_percent,
                    "valueType": "percentage",
                    "title": `${discount_percent}% off post purchase`
                  }
                })
              });
              
            }

            // if(!offer_duplicates && item_is_in_cart) TODO -- duplicates filter logic

            let pp_offer_id = offer_product_var_ids.join("");
            if(!window.cart_pp_offers.some(obj => obj.pp_offer_id == pp_offer_id)){

              window.cart_pp_offers.push({
                "pp_offer_id": pp_offer_id,
                "pp_offer_banner_title": banner_title,
                "pp_offer_banner_subtitle": `Save ${discount_percent}% with this offer`,
                "pp_offer_title": offer_product_titles,
                "pp_offer_image_url": offer_product_images[0],
                "pp_offer_description": [
                  offer_description
                ],
                "pp_offer_compare_at": offer_price.toFixed(2),
                "pp_offer_price": (offer_price * discount_multiplier).toFixed(2),
                "changes": pp_changes
              });

            }
            
          }

        }).catch();
      }

      
    }

    push_pp_offers();

  }

});

 // CHIRP 14 - Unified Bundle Selector
(function () {
  "use strict";

  const PRODUCT_HANDLE = "chirp-halo-wireless-muscle-stim-double";
  const BUNDLE_IMAGE =
    "https://gochirp.com/cdn/shop/files/7-vert.jpg?v=1761770807&width=200";
  const MAIN_PRODUCT = {
    title: "Chirp Halo Wireless Muscle Stim",
    image:
      "https://gochirp.com/cdn/shop/files/7-vert.jpg?v=1761770807&width=400",
  };
  const BASE_PRICE = 179.99;
  const BASE_COMPARE_AT = 199.99;

  const PAD_INFO = {
    41597672095767: { title: "Ultimate Lower Back Relief", price: 16.99, description: "Contoured pads for optimal lower back coverage", image: "https://gochirp.com/cdn/shop/files/1-hero_e7b403c0-a1be-42bf-a0f8-25a37e255a5f.png?v=1762275695&width=200" },
    41597696409623: { title: "Ultimate Glute Relief", price: 15.99, description: "Large coverage pads for glute muscle stimulation", image: "https://gochirp.com/cdn/shop/files/1-hero_8c4f085f-83bd-431b-8e6b-d5f3b1b5c149.png?v=1722966235&width=200" },
    41597697720343: { title: "Ultimate Quad Relief", price: 15.99, description: "Elongated pads for quadricep muscle targeting", image: "https://gochirp.com/cdn/shop/files/1-hero_fcdef5aa-d313-43eb-85f5-383d1607dbdd.png?v=1722966355&width=200" },
    41597671079959: { title: "Ultimate Upper Back Relief", price: 16.99, description: "Wide pads for thoracic spine and upper back relief", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    41597674848279: { title: "Ultimate TFL/Hip Flexor Relief", price: 15.99, description: "Specialized pads for hip flexor and TFL targeting", image: "https://gochirp.com/cdn/shop/files/1-hero_e07c60da-5074-49ea-bce5-6ceeb8764787.png?v=1722964745&width=200" },
    42175501860887: { title: "Ultimate Trigger Point Relief", price: 18.99, description: "Small precision pads for targeted trigger point therapy", image: "https://gochirp.com/cdn/shop/files/1-chirp-halo-pads-triggerpoint-hero.png?v=1762277582&width=200" },
    41597674192919: { title: "Ultimate Trap Relief", price: 16.99, description: "Curved pads designed for trapezius muscle relief", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    41597672554519: { title: "Ultimate Shoulder Relief", price: 16.99, description: "Flexible pads for deltoid and shoulder coverage", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    42902832021527: { title: "Ultimate Knee Relief", price: 18.99, description: "Contoured pads for around-knee muscle support", image: "https://gochirp.com/cdn/shop/files/1-hero_fcdef5aa-d313-43eb-85f5-383d1607dbdd.png?v=1722966355&width=200" },
    41597700079639: { title: "Ultimate Calf Relief", price: 15.99, description: "Wrap-around pads for calf muscle stimulation", image: "https://gochirp.com/cdn/shop/files/1-hero_2bbe88b9-0b98-4331-ba0a-5178b03995d9.png?v=1722966546&width=200" },
    42568201011223: { title: "Ultimate Menstrual Relief", price: 14.99, description: "Gentle pads designed for menstrual pain relief", image: "https://gochirp.com/cdn/shop/files/1-hero_5a9ef071-9085-468f-a331-b930b67d1728.png?v=1762278777&width=200" },
    42568177254423: { title: "Ultimate Foot Relief", price: 16.99, description: "Compact pads for plantar and foot muscle relief", image: "https://gochirp.com/cdn/shop/files/1-hero_458287f8-9b9f-4a8f-98a1-f804d49b9e62.png?v=1762278777&width=200" },
  };

  const BUNDLES_V1 = {
    title: "Choose Where You Need Relief",
    bundles: [
      { id: "device-only", title: "Basic Relief", isDeviceOnly: true, description: "", items: [] },
      { id: "lower-back", title: "Ultimate Lower Back Relief", description: "Complete pad set targeting lower back pain and related muscle groups", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 41597696409623 },{ quantity: 1, variantId: 41597697720343 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597674848279 }] },
      { id: "upper-back", title: "Ultimate Upper Back Relief", description: "Comprehensive pad collection for upper back and shoulder tension", items: [{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597674192919 },{ quantity: 1, variantId: 41597672554519 }] },
      { id: "knee", title: "Ultimate Knee Pain Relief", description: "Targeted pad set for knee pain and surrounding muscle support", items: [{ quantity: 2, variantId: 42902832021527 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597697720343 },{ quantity: 1, variantId: 41597700079639 }] },
      { id: "neck", title: "Ultimate Neck Pain Relief", description: "Specialized pads for neck tension and cervical support", items: [{ quantity: 1, variantId: 41597672554519 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 2, variantId: 41597674192919 }] },
      { id: "menstrual", title: "Ultimate Menstrual Relief", description: "Gentle relief pads designed for menstrual discomfort", items: [{ quantity: 2, variantId: 42568201011223 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42568177254423 }] },
      { id: "foot", title: "Ultimate Foot Pain Relief", description: "Complete foot and lower leg pad collection", items: [{ quantity: 2, variantId: 42568177254423 },{ quantity: 2, variantId: 41597700079639 },{ quantity: 1, variantId: 42175501860887 }] },
      { id: "restless-legs", title: "Ultimate Restless Legs Relief", description: "Full leg coverage for restless leg syndrome relief", items: [{ quantity: 1, variantId: 42568177254423 },{ quantity: 1, variantId: 41597700079639 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597697720343 },{ quantity: 1, variantId: 41597696409623 }] },
    ],
  };

  const BUNDLES_V2 = {
    title: "Choose Targeted Relief Based on Your Life",
    bundles: [
      { id: "device-only", title: "Basic Relief", isDeviceOnly: true, description: "", items: [] },
      { id: "desk-job", title: "Desk Job Professional", description: "Perfect for office workers dealing with posture-related tension and sedentary lifestyle discomfort", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597674192919 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 42568177254423 }] },
      { id: "chronic-pain", title: "Chronic Pain Sufferer", description: "Comprehensive relief for those managing ongoing pain conditions", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 41597696409623 },{ quantity: 1, variantId: 41597697720343 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597674848279 }] },
      { id: "parent", title: "Parent", description: "Relief for the demands of parenting - lifting, carrying, and constant movement", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 42902832021527 },{ quantity: 1, variantId: 42568177254423 },{ quantity: 1, variantId: 41597671079959 }] },
      { id: "traveler", title: "Frequent Traveler", description: "Combat the strain of long flights, car rides, and carrying luggage", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597700079639 },{ quantity: 1, variantId: 42568177254423 },{ quantity: 1, variantId: 41597674192919 }] },
      { id: "athlete", title: "Athlete / Fitness Enthusiast", description: "Optimize recovery and performance for active lifestyles", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 42902832021527 },{ quantity: 1, variantId: 42568177254423 }] },
    ],
  };

  let activeConfig = null;
  let selectedBundle = null;
  let carouselPosition = 0;
  let currentPopupBundleIndex = 0;
  let mainProductVariantId = null;
  let previouslyFocusedElement = null;
  const ITEMS_VISIBLE_FALLBACK = 1.8, ITEM_GAP = 8;

  function getActualItemWidth(carousel) {
    const firstItem = carousel.querySelector(".halo-bundle-carousel__item");
    if (!firstItem) return 180;
    return firstItem.getBoundingClientRect().width;
  }

  function getItemsVisible(carousel) {
    const tw = carousel.querySelector(".halo-bundle-carousel__track-wrapper");
    if (!tw || tw.offsetWidth === 0) return ITEMS_VISIBLE_FALLBACK;
    const itemWidth = getActualItemWidth(carousel);
    if (itemWidth === 0) return ITEMS_VISIBLE_FALLBACK;
    return (tw.offsetWidth + ITEM_GAP) / (itemWidth + ITEM_GAP);
  }

  function getVariantImage(variantId) {
    const p = PAD_INFO[variantId];
    return p && p.image ? p.image : BUNDLE_IMAGE;
  }

  function getMainProductVariantId() {
    if (mainProductVariantId) return mainProductVariantId;
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) { const v = form.querySelector('input[name="id"]'); if (v) { mainProductVariantId = parseInt(v.value, 10); return mainProductVariantId; } }
    const sel = document.querySelector('select[name="id"]');
    if (sel) { mainProductVariantId = parseInt(sel.value, 10); return mainProductVariantId; }
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) { mainProductVariantId = window.ShopifyAnalytics.meta.selectedVariantId; return mainProductVariantId; }
    return null;
  }

  function openCartDrawer() {
    if (typeof CartManager !== "undefined") {
      if (typeof CartManager.openCart === "function") { CartManager.openCart(); return true; }
      if (typeof CartManager.open === "function") { CartManager.open(); return true; }
      if (typeof CartManager.showCart === "function") { CartManager.showCart(); return true; }
      if (typeof CartManager.toggleCart === "function") { CartManager.toggleCart(); return true; }
    }
    if (typeof window.openCartDrawer === "function") { window.openCartDrawer(); return true; }
    if (typeof window.openCart === "function") { window.openCart(); return true; }
    if (typeof window.CartDrawer !== "undefined" && typeof window.CartDrawer.open === "function") { window.CartDrawer.open(); return true; }
    if (typeof window.Shopify !== "undefined" && window.Shopify.CartDrawer && typeof window.Shopify.CartDrawer.open === "function") { window.Shopify.CartDrawer.open(); return true; }
    const triggers = ["[data-cart-trigger]",'[data-action="open-cart"]',"[data-open-cart]",".cart-icon-bubble",".site-header__cart",".header__icon--cart",".js-cart-toggle",".cart-toggle",".cart-btn","#cart-icon-bubble",'a[href="/cart"].header__icon','button[aria-controls="cart-drawer"]','[aria-controls="CartDrawer"]',".header-cart-btn",".mini-cart-trigger"];
    for (const s of triggers) { const el = document.querySelector(s); if (el) { el.click(); return true; } }
    ["cart:open","theme:cart:open","cart-drawer:open","open-cart"].forEach((e) => { document.dispatchEvent(new CustomEvent(e)); window.dispatchEvent(new CustomEvent(e)); });
    const drawers = ["#CartDrawer","#cart-drawer",".cart-drawer",".mini-cart",".side-cart","[data-cart-drawer]",".drawer--cart"];
    for (const s of drawers) { const d = document.querySelector(s); if (d) { d.classList.add("is-open","active","open","is-active"); d.setAttribute("aria-hidden","false"); const o = document.querySelector(".drawer-overlay, .cart-overlay, .site-overlay"); if (o) o.classList.add("is-visible","active"); document.body.classList.add("cart-open","drawer-open","overflow-hidden"); return true; } }
    return false;
  }

  // Returns { price, compareAt } — compareAt includes original base price + full pad prices
  function calculateBundlePrice(b) {
    if (!b || b.isDeviceOnly) {
      return { price: BASE_PRICE, compareAt: BASE_COMPARE_AT };
    }
    let discountedPadsTotal = 0;
    let fullPadsTotal = 0;
    b.items.forEach((item) => {
      const padInfo = PAD_INFO[item.variantId];
      if (padInfo) {
        const discountedPadPrice = Math.round(padInfo.price * 0.8 * 100) / 100;
        discountedPadsTotal += discountedPadPrice * item.quantity;
        fullPadsTotal += padInfo.price * item.quantity;
      }
    });
    return {
      price: Math.round((BASE_PRICE + discountedPadsTotal) * 100) / 100,
      compareAt: Math.round((BASE_COMPARE_AT + fullPadsTotal) * 100) / 100,
    };
  }

  function formatPrice(a) {
    return "$" + a.toFixed(2);
  }

  // Returns HTML: strikethrough compare-at + sale price in red
  function formatPriceWithCompare(price, compareAt) {
    if (compareAt > price) {
      return '<span class="halo-price-compare">' + formatPrice(compareAt) + '</span> <span class="halo-price-sale">' + formatPrice(price) + '</span>';
    }
    return '<span class="halo-price-sale">' + formatPrice(price) + '</span>';
  }

  // Helper for the popup add-to-cart button text (white strikethrough on dark bg)
  function formatAddBtnPrice(price, compareAt) {
    if (compareAt > price) {
      return 'Add to Cart - <span style="text-decoration:line-through;opacity:.6;font-weight:400;margin-right:4px;">' + formatPrice(compareAt) + '</span> ' + formatPrice(price);
    }
    return 'Add to Cart - ' + formatPrice(price);
  }

  function updatePrice(b) {
    const { price, compareAt } = calculateBundlePrice(b);
    // Only update the sale price text — the site already renders its own compare-at strikethrough
    ["#chirpProductPrice strong.text-chirp-blue-dark",".product__price .price-item--regular",".product-single__price","[data-product-price]"].forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) el.textContent = formatPrice(price);
    });
    // Also update the site's native compare-at price if present
    ["#chirpProductPrice .text-chirp-gray-medium s","#chirpProductPrice s",".product__price .price-item--sale s",".compare-at-price"].forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) el.textContent = formatPrice(compareAt);
    });
  }

  function selectBundle(id) {
    document.querySelectorAll(".halo-bundle-carousel__item").forEach((el) => {
      const s = el.dataset.bundleId === id;
      el.classList.toggle("selected", s);
      el.setAttribute("aria-pressed", s ? "true" : "false");
    });
    selectedBundle = activeConfig.bundles.find((b) => b.id === id) || activeConfig.bundles[0];
    updatePrice(selectedBundle);
    announceToScreenReader("Selected " + selectedBundle.title + " bundle");
  }

  function addToCart(bundle) {
    const variantId = getMainProductVariantId();
    if (!variantId) { console.error("Could not find main product variant ID"); alert("Error: Could not add to cart. Please try the main Add to Cart button."); return Promise.reject("No variant ID"); }
    const items = [{ id: variantId, quantity: 1 }];
    if (bundle && !bundle.isDeviceOnly && bundle.items && bundle.items.length > 0) { bundle.items.forEach((item) => { items.push({ id: item.variantId, quantity: item.quantity }); }); }
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) })
      .then((r) => { if (!r.ok) throw new Error("Add to cart failed"); return r.json(); })
      .then((data) => {
        if (typeof CartManager !== "undefined") { ["reloadCartCount","reloadMainCart","refresh","updateCart"].forEach((m) => { if (typeof CartManager[m] === "function") CartManager[m](); }); }
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:item-added"));
        fetch("/cart.js").then((r) => r.json()).then((cart) => { document.querySelectorAll(".cart-count, .cart-item-count, [data-cart-count], .header__cart-count").forEach((el) => { el.textContent = cart.item_count; }); });
        return data;
      });
  }

  function announceToScreenReader(msg) {
    let a = document.getElementById("halo-sr-announcer");
    if (!a) { a = document.createElement("div"); a.id = "halo-sr-announcer"; a.setAttribute("aria-live","polite"); a.setAttribute("aria-atomic","true"); a.className = "halo-sr-only"; document.body.appendChild(a); }
    a.textContent = "";
    setTimeout(() => { a.textContent = msg; }, 100);
  }

  function injectStyles() {
    if (document.getElementById("halo-bundle-styles-14")) return;
    const s = document.createElement("style");
    s.id = "halo-bundle-styles-14";
    s.textContent = '.halo-price-compare{text-decoration:line-through;color:#999;font-weight:400;font-size:.85em;margin-right:4px}.halo-price-sale{color:#e53e3e;font-weight:700}.halo-popup__main-product-price .halo-price-compare{font-size:13px}.halo-popup__main-product-price .halo-price-sale{font-size:15px;color:#e53e3e}.halo-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.halo-bundle-carousel__container,.halo-bundle-carousel__item{box-sizing:border-box;position:relative}.halo-bundle-carousel{margin:1rem 0;width:100%;box-sizing:border-box}.halo-bundle-carousel__title{color:#0b0f14;font-weight:700}.halo-bundle-carousel__track-wrapper{display:grid;width:100%;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;padding:8px 0;scroll-snap-type:x mandatory;scroll-padding-inline-start:4px}.halo-bundle-carousel__track-wrapper::-webkit-scrollbar{display:none}.halo-bundle-carousel__track{display:flex;padding:0 4px;gap:8px}.halo-bundle-carousel__item{flex:0 0 180px;padding:8px;gap:8px;cursor:pointer;transition:transform .15s,box-shadow .15s,border-color .15s;background:#fff;display:flex;flex-direction:row;align-items:flex-start;scroll-snap-align:start;border:1px solid #c6c6c6;border-radius:20px;box-shadow:0 5px 5px rgb(10 20 30 / .06);flex-wrap:wrap}.halo-bundle-carousel__item:hover{transform:translateY(-2px);box-shadow:0 8px 4px rgb(10 20 30 / .1)}.halo-bundle-carousel__item:focus-visible{outline:#000 solid 3px;outline-offset:2px}.halo-bundle-carousel__item.selected{border-color:rgb(139 141 145 / 1);box-shadow:0 0 0 4px rgb(139 141 145 / .32),0 6px 2px rgb(10 20 30 / .12)}.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-description,.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-price,.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-title{color:#1a1a1a}.halo-bundle-carousel__item.selected .halo-bundle-carousel__more-info{box-shadow:0 12px 26px rgb(35 110 249 / .28)}.halo-bundle-carousel__item-image-wrap{flex:0 0 34%;aspect-ratio:10/10;border-radius:14px;border:1px solid #e6ebf0;background:#f7fafc;overflow:hidden}.halo-bundle-carousel__item-image{width:100%;height:100%;object-fit:cover}.halo-bundle-carousel__item-content{display:grid}.halo-bundle-carousel__item-title{color:#1a1a1a;font-size:12px;font-weight:600;margin:0 0 4px;line-height:1.2;white-space:wrap;overflow:hidden}.halo-bundle-carousel__item-price{color:#1a1a1a;font-size:13px;font-weight:700;margin:0 0 4px}.halo-bundle-carousel__item-description{font-size:11px;margin:0;color:#5b6672;display:flex;gap:8px;align-items:center}.halo-bundle-carousel__item-description:not(:empty)::before{content:"";width:8px;height:8px;border-radius:50%;background:#236ef9;box-shadow:0 0 0 3px rgb(35 110 249 / .16)}.halo-bundle-carousel__savings-badge{display:none;position:absolute;top:-6px;left:-6px;background:linear-gradient(135deg,#22c55e 0,#16a34a 100%);color:#fff;font-size:9px;font-weight:700;padding:3px 6px;border-radius:4px;white-space:nowrap;box-shadow:0 2px 4px rgb(0 0 0 / .15);z-index:5;text-transform:uppercase;letter-spacing:.3px}.halo-bundle-carousel__more-info{font-size:12px;width:100%;line-height:0;padding:13px;border-radius:20px;border:1px solid #fff0;background:#236ef9;color:#fff;font-weight:600;cursor:pointer;display:grid;place-items:center;transition:background .15s,transform .15s,box-shadow .15s;align-self:end}.halo-bundle-carousel__more-info:hover{background:#154fba;box-shadow:0 10px 22px rgb(35 110 249 / .22)}.halo-bundle-carousel__dot:hover,.halo-popup__switcher-dot:hover:not(.active){background:#bbb}.halo-bundle-carousel__more-info:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__nav{width:44px;height:44px;border-radius:50%;background:#fff;border:1px solid #c6c6c6;cursor:pointer;display:grid;place-items:center;z-index:10;transition:transform .15s,box-shadow .15s,border-color .15s}.halo-bundle-carousel__nav:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__nav:disabled{opacity:.4;cursor:not-allowed;box-shadow:none}.halo-bundle-carousel__nav svg{width:22px;height:22px;fill:#0b0f14}.halo-bundle-carousel__dots{display:flex;justify-content:center;gap:8px;margin-top:2px}.halo-bundle-carousel__dot{position:relative;width:8px;height:8px;border-radius:50%;border:1px solid #c6c6c6;background:#eee;opacity:.9;cursor:pointer;transition:width .15s,background .15s,border-color .15s}.halo-popup,.halo-popup-overlay{position:fixed;opacity:0;visibility:hidden}.halo-bundle-carousel__dot::before{content:"";position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px}.halo-bundle-carousel__dot:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__dot.active{background:#3473e8;border-color:#154fba}.halo-popup-overlay{top:0;left:0;right:0;bottom:0;background:rgb(0 0 0 / .6);backdrop-filter:blur(4px);z-index:9999;transition:.3s}.halo-popup-overlay.active{opacity:1;visibility:visible}.halo-popup{top:50%;left:50%;transform:translate(-50%,-50%) scale(.95);background:#fff;border-radius:20px;width:92%;max-width:560px;max-height:90vh;overflow:hidden;box-shadow:0 25px 60px -12px rgb(0 0 0 / .3);z-index:10000;transition:.3s cubic-bezier(.4, 0, .2, 1);display:flex;flex-direction:column}.halo-popup-overlay.active .halo-popup{opacity:1;visibility:visible;transform:translate(-50%,-50%) scale(1)}.halo-popup__header{display:flex;flex-direction:column;align-items:center;padding:20px 16px;border-bottom:1px solid #eee;background:#fff;flex-shrink:0;position:relative}.halo-popup__close:hover,.halo-popup__switcher-btn:hover:not(:disabled){border-color:rgb(0 0 0 / .3)}.halo-popup__title-wrap{text-align:center;min-width:0;width:100%;padding:0 50px}.halo-popup__title{font-size:22px;font-weight:700;color:#1a1a1a;margin:0 0 6px;line-height:1.2}.halo-popup__subtitle{font-size:14px;color:#666;margin:0 0 12px;line-height:1.4}.halo-popup__nav-row{display:flex;align-items:center;justify-content:center;gap:16px;width:100%}.halo-popup__switcher-dots{display:flex;gap:8px;justify-content:center}.halo-popup__switcher-dot{width:10px;height:10px;border-radius:50%;background:#ddd;border:none;padding:0;cursor:pointer;transition:.2s;position:relative}.halo-popup__close,.halo-popup__switcher-btn{width:44px;height:44px;background:#fff;cursor:pointer}.halo-popup__close,.halo-popup__item,.halo-popup__switcher-btn{transition:border-color .2s;display:flex}.halo-popup__switcher-dot::before{content:"";position:absolute;top:-8px;right:-8px;bottom:-8px;left:-8px}.halo-popup__switcher-dot:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__switcher-dot.active{background:#000}.halo-popup__switcher-btn{border-radius:50%;border:2px solid;align-items:center;justify-content:center;flex-shrink:0}.halo-popup__switcher-btn:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__switcher-btn:disabled{opacity:.35;cursor:not-allowed}.halo-popup__switcher-btn svg{width:18px;height:18px;fill:#333}.halo-popup__close{border-radius:50%;border:2px solid;align-items:center;justify-content:center;flex-shrink:0;position:absolute;top:16px;right:16px}.halo-popup__close:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__close svg{width:20px;height:20px;fill:#666}.halo-popup__body{padding:24px;overflow-y:auto;flex:1}.halo-popup__section{margin-bottom:24px}.halo-popup__section:last-child{margin-bottom:0}.halo-popup__section-title{font-size:12px;font-weight:700;color:#888;text-transform:uppercase;letter-spacing:.8px;margin:0 0 14px;display:flex;align-items:center;gap:12px}.halo-popup__section-title::after{content:"";flex:1;height:1px;background:#eee}.halo-popup__main-product{display:flex;gap:16px;padding:8px;background:#fafafa;border-radius:10px;border:2px solid}.halo-popup__main-product-image{width:80px;height:80px;object-fit:contain;border-radius:10px;background:#fff;padding:8px;flex-shrink:0}.halo-popup__main-product-info{flex:1;min-width:0}.halo-popup__main-product-title{font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 4px;line-height:1.3}.halo-popup__main-product-price{font-size:15px;font-weight:700;color:#1a1a1a;margin:0 0 6px}.halo-popup__savings-banner{background:#edf979;color:#012287;padding:10px 14px;border-radius:8px;margin-bottom:14px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:600}.halo-popup__savings-banner svg{width:18px;height:18px;fill:#012287;flex-shrink:0}.halo-popup__items-list{display:flex;flex-direction:column;gap:10px}.halo-popup__item{gap:14px;padding:4px;background:#fff;border-radius:10px;border:2px solid}.halo-popup__item:hover{border-color:rgb(0 0 0 / .2)}.halo-popup__item-image{width:52px;height:52px;object-fit:contain;border-radius:8px;background:#fff;flex-shrink:0;border:1px solid #eee}.halo-popup__item-info{flex:1;min-width:0;display:flex;flex-direction:column;justify-content:center}.halo-popup__item-row{display:flex;justify-content:space-between;align-items:center;gap:12px}.halo-popup__item-title{font-size:14px;font-weight:600;color:#1a1a1a;margin:0;line-height:1.3}.halo-popup__item-qty{font-size:13px;color:#000;font-weight:600;background:#f0f0f0;padding:4px 10px;border-radius:12px;white-space:nowrap}.halo-popup__item-desc{font-size:12px;color:#666;margin:6px 0 0;line-height:1.4}.halo-popup__footer{border-top:1px solid #eee;background:#fafafa;flex-shrink:0}.halo-popup__cart-section{padding:18px 24px;display:flex;align-items:center;justify-content:center}.halo-popup__add-btn{padding:16px 32px;background:#000;color:#fff;border:none;border-radius:10px;font-size:16px;font-weight:600;cursor:pointer;transition:background .2s;white-space:nowrap;min-height:52px}.halo-popup__add-btn:hover{background:#333}.halo-popup__add-btn:focus-visible{outline:#000 solid 3px;outline-offset:3px}.halo-popup__add-btn:disabled{background:#ccc;cursor:not-allowed}.halo-popup__add-btn--loading{pointer-events:none}.halo-popup__add-btn--loading::after{content:"";display:inline-block;width:16px;height:16px;border:2px solid #fff0;border-top-color:#fff;border-radius:50%;animation:.8s linear infinite halo-spin;margin-left:10px;vertical-align:middle}@keyframes halo-spin{to{transform:rotate(360deg)}}.halo-bundle-carousel-desktop-wrapper{display:none}@media (min-width:1024px){.halo-bundle-carousel-desktop-wrapper{display:flex;margin:0 20px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel{margin:0 auto}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__container{display:grid;grid-template-columns:44px 1fr 44px;align-items:center;gap:4px;max-width:612px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__title{text-align:center;line-height:1.1;font-size:14px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item{flex:0 0 250px}.halo-bundle-carousel__item.selected{box-shadow:0 0 0 4px rgb(139 141 145 / .52),0 6px 2px rgb(10 20 30 / .22)}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-content{flex:0 0 50%}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-price{font-size:1rem}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-description{font-size:12px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__savings-badge{font-size:8px;padding:2px 5px;top:-5px;left:-5px}#chirpProductCta{width:auto;max-width:none}#chirpProductCta .product-form__submit{min-height:55px;height:auto!important}#chirpProductPrice{gap:0;flex-direction:column}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__nav:hover:not(:disabled){transform:translateY(-1px);border-color:rgb(35 110 249 / .45);box-shadow:0 12px 28px rgb(10 20 30 / .12)}}@media (max-width:480px){.halo-popup{width:95%;max-height:92vh}.halo-popup__close,.halo-popup__switcher-btn{width:40px;height:40px}.halo-popup__header{padding:20px 14px}.halo-popup__title{font-size:20px}.halo-popup__subtitle{font-size:13px}.halo-popup__close{top:12px;right:12px}.halo-popup__body{padding:18px}.halo-popup__main-product{flex-direction:row;align-items:center;text-align:center;padding:8px}.halo-popup__main-product-image{width:90px;height:90px}.halo-popup__cart-section{padding:16px 18px}.halo-popup__add-btn{width:100%;padding:18px}.halo-bundle-carousel__container{padding:0 40px}.halo-bundle-carousel__item{flex-direction:column}.halo-bundle-carousel__item-image-wrap{flex:0 0 auto}.halo-bundle-carousel__title{margin-bottom:5px;font-size:1rem}.halo-bundle-carousel__item-price{font-size:1rem}.halo-bundle-carousel__item-description{font-size:12px}.halo-bundle-carousel__more-info{margin-top:auto}.halo-bundle-carousel__nav{position:absolute;top:50%;transform:translateY(-50%)}.halo-bundle-carousel__nav--prev{left:-13px}.halo-bundle-carousel__nav--next{right:-13px}.halo-bundle-carousel__dots{margin-top:15px}}@media (prefers-reduced-motion:reduce){.halo-bundle-carousel__dot,.halo-bundle-carousel__item,.halo-bundle-carousel__more-info,.halo-bundle-carousel__nav,.halo-bundle-carousel__track,.halo-popup,.halo-popup-overlay,.halo-popup__add-btn,.halo-popup__close,.halo-popup__item,.halo-popup__switcher-btn,.halo-popup__switcher-dot{transition:none!important;animation:none!important}}'
    document.head.appendChild(s);
  }
  
  function getMaxPosition(carousel) {
    const itemsVisible = carousel ? getItemsVisible(carousel) : ITEMS_VISIBLE_FALLBACK;
    return Math.max(0, Math.ceil(activeConfig.bundles.length - itemsVisible));
  }

  function updateDots(carousel) {
    const dotsContainer = carousel.querySelector(".halo-bundle-carousel__dots");
    if (!dotsContainer) return;
    const max = getMaxPosition(carousel);
    const total = max + 1;
    if (carouselPosition > max) carouselPosition = max;
    let h = "";
    for (let i = 0; i < total; i++) { const isActive = i === carouselPosition; h += '<button class="halo-bundle-carousel__dot' + (isActive ? " active" : "") + '" data-position="' + i + '" aria-label="Go to slide ' + (i + 1) + " of " + total + '"' + (isActive ? ' aria-current="true"' : "") + "></button>"; }
    dotsContainer.innerHTML = h;
    dotsContainer.querySelectorAll(".halo-bundle-carousel__dot").forEach((dot) => { dot.addEventListener("click", (e) => { e.preventDefault(); const pos = parseInt(dot.dataset.position, 10); if (!isNaN(pos) && pos !== carouselPosition) { carouselPosition = pos; updateAllCarousels(); } }); });
  }

  function createDotsHTML() { return ""; }

  function createCarouselHTML() {
    const usedImages = new Set();
    const itemsHTML = activeConfig.bundles.map((b, idx) => {
      const { price, compareAt } = calculateBundlePrice(b);
      const priceHTML = formatPriceWithCompare(price, compareAt);
      const moreBtn = '<button class="halo-bundle-carousel__more-info" data-bundle-index="' + idx + '" aria-label="View details for ' + b.title + ' bundle">View details</button>';
      let img = BUNDLE_IMAGE;
      if (!b.isDeviceOnly && b.items.length > 0) {
        const bundleImages = b.items.map(item => getVariantImage(item.variantId));
        const available = bundleImages.filter(i => !usedImages.has(i));
        const pool = available.length > 0 ? available : bundleImages;
        img = pool[Math.floor(Math.random() * pool.length)];
        usedImages.add(img);
      }
      const isFirst = idx === 0;
      const selectedClass = isFirst ? " selected" : "";
      const ariaPressed = isFirst ? "true" : "false";
      const savingsBadge = !b.isDeviceOnly ? '<span class="halo-bundle-carousel__savings-badge">Save 20%</span>' : "";

      if (b.isDeviceOnly) {
        return '<div class="halo-bundle-carousel__item halo-bundle-carousel__item--device-only' + selectedClass + '" data-bundle-id="' + b.id + '" data-bundle-index="' + idx + '" role="button" tabindex="0" aria-pressed="' + ariaPressed + '" aria-label="' + b.title + ", " + formatPrice(price) + ', device only with no pads"><div class="halo-bundle-carousel__item-image-wrap"><img class="halo-bundle-carousel__item-image" src="' + BUNDLE_IMAGE + '" alt="" aria-hidden="true"></div><div class="halo-bundle-carousel__item-content"><p class="halo-bundle-carousel__item-title">' + b.title + '</p><p class="halo-bundle-carousel__item-price">' + priceHTML + '</p><p class="halo-bundle-carousel__item-description"></p></div>' + moreBtn + "</div>";
      }
      const cnt = b.items.reduce((s, i) => s + i.quantity, 0);
      return '<div class="halo-bundle-carousel__item' + selectedClass + '" data-bundle-id="' + b.id + '" data-bundle-index="' + idx + '" role="button" tabindex="0" aria-pressed="' + ariaPressed + '" aria-label="' + b.title + " bundle, " + formatPrice(price) + ", includes " + cnt + ' pad sets, save 20% on pads"><div class="halo-bundle-carousel__item-image-wrap">' + savingsBadge + '<img class="halo-bundle-carousel__item-image" src="' + img + '" alt="" aria-hidden="true"></div><div class="halo-bundle-carousel__item-content"><p class="halo-bundle-carousel__item-title">' + b.title + '</p><p class="halo-bundle-carousel__item-price">' + priceHTML + '</p><p class="halo-bundle-carousel__item-description">' + cnt + " pads included</p></div>" + moreBtn + "</div>";
    }).join("");

    return '<div class="halo-bundle-carousel" role="region" aria-label="Bundle selection carousel"><h3 class="halo-bundle-carousel__title" id="halo-carousel-heading">' + activeConfig.title + '</h3><div class="halo-bundle-carousel__container"><button class="halo-bundle-carousel__nav halo-bundle-carousel__nav--prev" disabled aria-label="Previous bundles"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button><div class="halo-bundle-carousel__track-wrapper"><div class="halo-bundle-carousel__track" role="listbox" aria-labelledby="halo-carousel-heading">' + itemsHTML + '</div></div><button class="halo-bundle-carousel__nav halo-bundle-carousel__nav--next" aria-label="Next bundles"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg></button></div><div class="halo-bundle-carousel__dots" role="tablist" aria-label="Carousel pagination">' + createDotsHTML() + "</div></div>";
  }

  function createPopupHTML() {
    return '<div class="halo-popup-overlay" id="haloBundlePopup" role="dialog" aria-modal="true" aria-labelledby="popupTitle" aria-describedby="popupSubtitle"><div class="halo-popup"><div class="halo-popup__header"><div class="halo-popup__title-wrap"><h2 class="halo-popup__title" id="popupTitle">What\'s Included</h2><p class="halo-popup__subtitle" id="popupSubtitle">Bundle details</p></div><div class="halo-popup__nav-row"><button class="halo-popup__switcher-btn" id="popupPrev" aria-label="Previous bundle"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button><div class="halo-popup__switcher-dots" id="popupDots" role="tablist" aria-label="Bundle navigation"></div><button class="halo-popup__switcher-btn" id="popupNext" aria-label="Next bundle"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg></button></div><button class="halo-popup__close" id="popupClose" aria-label="Close dialog"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></button></div><div class="halo-popup__body" id="popupBody"></div><div class="halo-popup__footer"><div class="halo-popup__cart-section"><button class="halo-popup__add-btn" id="popupAddBtn">Add to Cart</button></div></div></div></div>';
  }

  function updatePopupContent(idx) {
    const b = activeConfig.bundles[idx];
    if (!b) return;
    currentPopupBundleIndex = idx;

    document.getElementById("popupTitle").textContent = b.title + (b.isDeviceOnly ? "" : " Bundle");
    document.getElementById("popupSubtitle").textContent = b.description;

    const { price: bp, compareAt: bCompare } = calculateBundlePrice(b);
    document.getElementById("popupAddBtn").innerHTML = formatAddBtnPrice(bp, bCompare);

    const body = document.getElementById("popupBody");
    const mainPriceHTML = formatPriceWithCompare(BASE_PRICE, BASE_COMPARE_AT);
    const mainHTML = '<div class="halo-popup__section"><p class="halo-popup__section-title">Main Device</p><div class="halo-popup__main-product"><img class="halo-popup__main-product-image" src="' + MAIN_PRODUCT.image + '" alt="' + MAIN_PRODUCT.title + '"><div class="halo-popup__main-product-info"><h3 class="halo-popup__main-product-title">' + MAIN_PRODUCT.title + '</h3><p class="halo-popup__main-product-price">' + mainPriceHTML + '</p></div></div></div>';

    if (b.isDeviceOnly) {
      body.innerHTML = mainHTML + '<div style="display:none;"></div>';
    } else {
      const cnt = b.items.reduce((s, i) => s + i.quantity, 0);
      const totalSavings = Math.round((bCompare - bp) * 100) / 100;
      const savingsBanner = '<div class="halo-popup__savings-banner"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>You save ' + formatPrice(totalSavings) + ' with this bundle!</div>';
      const iHTML = b.items.map((i) => { const p = PAD_INFO[i.variantId] || { title: "Pad Set", description: "" }; const img = getVariantImage(i.variantId); return '<div class="halo-popup__item"><img class="halo-popup__item-image" src="' + img + '" alt="' + p.title + '"><div class="halo-popup__item-info"><div class="halo-popup__item-row"><h4 class="halo-popup__item-title">' + p.title + '</h4><span class="halo-popup__item-qty">\u00d7' + i.quantity + '</span></div><p class="halo-popup__item-desc">' + p.description + '</p></div></div>'; }).join("");
      body.innerHTML = mainHTML + '<div class="halo-popup__section"><p class="halo-popup__section-title">Included Pad Sets (' + cnt + ')</p>' + savingsBanner + '<div class="halo-popup__items-list">' + iHTML + '</div></div>';
    }

    const dc = document.getElementById("popupDots");
    dc.innerHTML = activeConfig.bundles.map((x, i) => '<button class="halo-popup__switcher-dot' + (i === idx ? " active" : "") + '" data-index="' + i + '" aria-label="View ' + x.title + ' bundle"' + (i === idx ? ' aria-current="true"' : "") + '></button>').join("");
    document.getElementById("popupPrev").disabled = idx === 0;
    document.getElementById("popupNext").disabled = idx === activeConfig.bundles.length - 1;
    dc.querySelectorAll(".halo-popup__switcher-dot").forEach((d) => { d.addEventListener("click", () => updatePopupContent(parseInt(d.dataset.index, 10))); });
  }

  function openPopup(idx) {
    previouslyFocusedElement = document.activeElement;
    let popup = document.getElementById("haloBundlePopup");
    if (!popup) {
      document.body.insertAdjacentHTML("beforeend", createPopupHTML());
      popup = document.getElementById("haloBundlePopup");
      document.getElementById("popupClose").addEventListener("click", closePopup);
      popup.addEventListener("click", (e) => { if (e.target === popup) closePopup(); });
      document.getElementById("popupPrev").addEventListener("click", () => { if (currentPopupBundleIndex > 0) updatePopupContent(currentPopupBundleIndex - 1); });
      document.getElementById("popupNext").addEventListener("click", () => { if (currentPopupBundleIndex < activeConfig.bundles.length - 1) updatePopupContent(currentPopupBundleIndex + 1); });

      document.getElementById("popupAddBtn").addEventListener("click", function () {
        const btn = this;
        const b = activeConfig.bundles[currentPopupBundleIndex];
        const { price: bp, compareAt: bCompare } = calculateBundlePrice(b);
        btn.disabled = true;
        btn.classList.add("halo-popup__add-btn--loading");
        btn.textContent = "Adding";
        addToCart(b).then(() => {
          // console.log("BUNDLE ADDED", b);

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            'event': 'proteus_custom_event',
            'proteus_event_name': `[CHRP-14] ATC: ${b.id}`,
            'proteus_event_category': "CRO",
            'page_location': window.location.href
          });

          btn.textContent = "Added!";
          btn.classList.remove("halo-popup__add-btn--loading");
          selectBundle(b.id);
          announceToScreenReader(b.title + " bundle added to cart");
          setTimeout(() => { closePopup(); btn.disabled = false; btn.innerHTML = formatAddBtnPrice(bp, bCompare); setTimeout(() => { openCartDrawer(); }, 300); }, 600);
        }).catch((e) => {
          console.error("Add to cart error:", e);
          btn.disabled = false;
          btn.classList.remove("halo-popup__add-btn--loading");
          btn.innerHTML = formatAddBtnPrice(bp, bCompare);
          alert("Failed to add to cart. Please try again.");
        });
      });

      document.addEventListener("keydown", handlePopupKeydown);
    }
    updatePopupContent(idx);
    popup.classList.add("active");
    document.body.style.overflow = "hidden";
    setTimeout(() => { document.getElementById("popupClose").focus(); }, 100);
  }

  function handlePopupKeydown(e) {
    const p = document.getElementById("haloBundlePopup");
    if (!p || !p.classList.contains("active")) return;
    if (e.key === "Escape") closePopup();
    else if (e.key === "ArrowLeft" && currentPopupBundleIndex > 0) updatePopupContent(currentPopupBundleIndex - 1);
    else if (e.key === "ArrowRight" && currentPopupBundleIndex < activeConfig.bundles.length - 1) updatePopupContent(currentPopupBundleIndex + 1);
    else if (e.key === "Tab") {
      const f = p.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function closePopup() {
    const p = document.getElementById("haloBundlePopup");
    if (p) { p.classList.remove("active"); document.body.style.overflow = ""; if (previouslyFocusedElement) { previouslyFocusedElement.focus(); previouslyFocusedElement = null; } }
  }

  function updateCarousel(c, animate = true) {
    const tw = c.querySelector(".halo-bundle-carousel__track-wrapper");
    const pb = c.querySelector(".halo-bundle-carousel__nav--prev");
    const nb = c.querySelector(".halo-bundle-carousel__nav--next");
    if (!tw) return;
    if (tw.offsetWidth === 0) return;
    const max = getMaxPosition(c);
    if (carouselPosition > max) carouselPosition = max;
    const itemWidth = getActualItemWidth(c);
    const step = itemWidth + ITEM_GAP;
    const n = activeConfig.bundles.length;
    const totalContent = n * itemWidth + (n - 1) * ITEM_GAP;
    const maxScroll = Math.max(0, totalContent - tw.offsetWidth);
    const st = Math.min(carouselPosition * step, maxScroll);
    tw.scrollTo({ left: st, behavior: animate ? "smooth" : "auto" });
    pb.disabled = carouselPosition === 0;
    nb.disabled = carouselPosition >= max;
    const dots = c.querySelectorAll(".halo-bundle-carousel__dot");
    dots.forEach((d, i) => { const a = i === carouselPosition; d.classList.toggle("active", a); d.setAttribute("aria-current", a ? "true" : "false"); });
  }

  function updateAllCarousels(animate = true) { document.querySelectorAll(".halo-bundle-carousel").forEach((c) => updateCarousel(c, animate)); }

  function initializeCarousels() {
    document.querySelectorAll(".halo-bundle-carousel").forEach((carousel) => {
      const pb = carousel.querySelector(".halo-bundle-carousel__nav--prev");
      const nb = carousel.querySelector(".halo-bundle-carousel__nav--next");
      const items = carousel.querySelectorAll(".halo-bundle-carousel__item");
      const moreInfoBtns = carousel.querySelectorAll(".halo-bundle-carousel__more-info");
      const tw = carousel.querySelector(".halo-bundle-carousel__track-wrapper");
      updateDots(carousel);
      let scrollTimeout;
      if (tw) {
        tw.addEventListener("scroll", () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            if (tw.offsetWidth === 0) return;
            const itemWidth = getActualItemWidth(carousel);
            const step = itemWidth + ITEM_GAP;
            const max = getMaxPosition(carousel);
            const maxScrollActual = tw.scrollWidth - tw.offsetWidth;
            const np = tw.scrollLeft >= maxScrollActual - 2
              ? max
              : Math.min(Math.round(tw.scrollLeft / step), max);
            if (np !== carouselPosition && np >= 0) {
              carouselPosition = np;
              pb.disabled = carouselPosition === 0;
              nb.disabled = carouselPosition >= max;
              const dots = carousel.querySelectorAll(".halo-bundle-carousel__dot");
              dots.forEach((d, i) => { const a = i === carouselPosition; d.classList.toggle("active", a); d.setAttribute("aria-current", a ? "true" : "false"); });
              document.querySelectorAll(".halo-bundle-carousel").forEach((oc) => { if (oc !== carousel) updateCarousel(oc, false); });
            }
          }, 50);
        }, { passive: true });
      }
      items.forEach((item) => {
        item.addEventListener("click", function (e) { if (e.target.classList.contains("halo-bundle-carousel__more-info")) return; selectBundle(this.dataset.bundleId); });
        item.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); if (e.target.classList.contains("halo-bundle-carousel__more-info")) { openPopup(parseInt(e.target.dataset.bundleIndex, 10)); } else { selectBundle(this.dataset.bundleId); } } });
      });
      moreInfoBtns.forEach((btn) => { btn.addEventListener("click", function (e) { e.stopPropagation(); openPopup(parseInt(this.dataset.bundleIndex, 10)); }); });
      pb.addEventListener("click", (e) => { e.preventDefault(); if (carouselPosition > 0) { carouselPosition--; updateAllCarousels(); } });
      nb.addEventListener("click", (e) => { e.preventDefault(); const max = getMaxPosition(carousel); if (carouselPosition < max) { carouselPosition++; updateAllCarousels(); } });
      updateCarousel(carousel, false);
    });
  }

  function interceptMainAddToCart() {
    const forms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
    forms.forEach((form) => {
      if (form.dataset.haloIntercepted) return;
      form.dataset.haloIntercepted = "true";
      const submitBtns = form.querySelectorAll('[type="submit"], .product-form__submit, button[name="add"], .add-to-cart, .btn-addtocart');
      submitBtns.forEach((submitBtn) => {
        if (submitBtn.dataset.haloIntercepted) return;
        submitBtn.dataset.haloIntercepted = "true";
        submitBtn.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          const btn = this; const bundle = selectedBundle || activeConfig.bundles[0];
          btn.disabled = true; const prevText = btn.textContent; btn.textContent = "Adding...";
          addToCart(bundle).then(() => { btn.textContent = "Added!"; setTimeout(() => { btn.disabled = false; btn.textContent = prevText; openCartDrawer(); }, 800); }).catch(() => { btn.disabled = false; btn.textContent = prevText; alert("Failed to add to cart. Please try again."); });
        }, true);
      });
      form.addEventListener("submit", function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); const firstBtn = form.querySelector('[type="submit"], .product-form__submit, button[name="add"], .add-to-cart, .btn-addtocart'); if (firstBtn) firstBtn.click(); }, true);
    });
    document.querySelectorAll(".product-form__submit:not([data-halo-intercepted]), .add-to-cart:not([data-halo-intercepted]), [data-add-to-cart]:not([data-halo-intercepted])").forEach((btn) => {
      if (btn.closest("form[data-halo-intercepted]")) return;
      btn.dataset.haloIntercepted = "true";
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const bundle = selectedBundle || activeConfig.bundles[0];
        btn.disabled = true; const prevText = btn.textContent; btn.textContent = "Adding...";
        addToCart(bundle).then(() => { btn.textContent = "Added!"; setTimeout(() => { btn.disabled = false; btn.textContent = prevText; openCartDrawer(); }, 800); }).catch(() => { btn.disabled = false; btn.textContent = prevText; alert("Failed to add to cart. Please try again."); });
      }, true);
    });
  }

  function injectCarousel() {
    const mc = document.querySelector("#chirpProductCtaMobile");
    const ctaC = document.querySelector("#ctaContainer");
    const mainInfo = document.querySelector(".mainInfo");
    let injected = false;
    if (mc && !mc.querySelector(".halo-bundle-carousel")) { const d = document.createElement("div"); d.innerHTML = createCarouselHTML(); mc.insertBefore(d.firstElementChild, mc.firstChild); injected = true; }
    if (mainInfo && ctaC && !mainInfo.querySelector(".halo-bundle-carousel-desktop-wrapper")) { const w = document.createElement("div"); w.className = "halo-bundle-carousel-desktop-wrapper"; w.innerHTML = createCarouselHTML(); mainInfo.insertBefore(w, ctaC); injected = true; }
    if (!injected) return;
    getMainProductVariantId();
    if (window.innerWidth >= 1024 && mainInfo) { mainInfo.style.padding = "8px 15px"; }
    let rt;
    window.addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(() => { document.querySelectorAll(".halo-bundle-carousel").forEach((c) => { if (c.querySelector(".halo-bundle-carousel__track-wrapper")?.offsetWidth > 0) { updateDots(c); } }); updateAllCarousels(); }, 100); });
    initializeCarousels();
    selectedBundle = activeConfig.bundles[0];
    updatePrice(activeConfig.bundles[0]);
    interceptMainAddToCart();
    setTimeout(interceptMainAddToCart, 500);
    setTimeout(interceptMainAddToCart, 1500);
    const observer = new MutationObserver((mutations) => { let shouldReintercept = false; mutations.forEach((mutation) => { if (mutation.addedNodes.length > 0) { mutation.addedNodes.forEach((node) => { if (node.nodeType === 1 && node.matches && (node.matches('form[action*="/cart/add"]') || (node.querySelector && node.querySelector('form[action*="/cart/add"]')))) { shouldReintercept = true; } }); } }); if (shouldReintercept) setTimeout(interceptMainAddToCart, 100); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function activate(config) {
    if (window._chirp_14_activated) return;
    window._chirp_14_activated = true;
    activeConfig = config;
    injectStyles();
    if (window.location.pathname.includes(PRODUCT_HANDLE)) { setTimeout(injectCarousel, 100); }
  }

  window.activate_chirp_14v1 = function () { activate(BUNDLES_V1); };
  window.activate_chirp_14v2 = function () { activate(BUNDLES_V2); };
})();
// CHRP-20 v1 — Chirp Wheel Base Add-On Selector
// Theme script: defines window.activate_chrp_20v1, called by Proteus Tool

(function () {
  "use strict";

  // ─── Config ──────────────────────────────────────────────────────────────────

  const BUNDLE_HANDLES = [
    "chirp-wheel-xr-3-pack",
    "chirp-wheel-xr-4-pack",
    "chirp-wheel-3-pack",
    "chirp-wheel-4-pack",
    "deep-tissue-bundle",
    "chirp-wheel-5-pack",
  ];

  const SINGLE_WHEEL_HANDLES = [
    "chirp-wheel-2-foot-roller",
    "chirp-wheel-4-focus",
    "chirp-wheel-6-deep-tissue",
    "chirp-wheel-10-firm",
    "chirp-wheel-12-gentle",
    "chirp-wheel-xl-super-comfort",
    "chirp-wheel-xr-2-foot-roller",
    "chirp-wheel-xr-4-neck-headache",
    "chirp-wheel-xr-6-knot-kneader",
    "chirp-wheel-xr-10-acupressure",
  ];

  const PRODUCT_HANDLES = [...BUNDLE_HANDLES, ...SINGLE_WHEEL_HANDLES];

  const BASE_ADDON = {
    variantId: 40762756399127,
    description: "Keep your wheels in one place — mount to wall or floor.",
    price: 29.99,
    compareAt: 49.99,
    image: "https://gochirp.com/cdn/shop/files/2-facing_57e31d1a-3fad-44a6-9349-f911aa97e3a7.png?v=1709992593&width=200",
  };

  // ─── State ───────────────────────────────────────────────────────────────────

  let selectedOption = "wheel-only";
  let mainProductVariantId = null;
  let wheelPrice = 0;
  let wheelCompareAt = 0;

  // ─── Product helpers ─────────────────────────────────────────────────────────

  function getCurrentHandle() {
    const parts = window.location.pathname.split("/products/");
    if (parts.length < 2) return "";
    return parts[1].split("/")[0].replace(/\/$/, "");
  }

  function isBundleProduct() {
    return BUNDLE_HANDLES.includes(getCurrentHandle());
  }

  function getOptionCopy() {
    if (isBundleProduct()) {
      return {
        primaryTitle: "Wheels",
        secondaryTitle: "Wheels + Base",
        primaryAria: "Wheels only",
        secondaryAria: `Add base to wheels for ${formatPrice(BASE_ADDON.price)}, was ${formatPrice(BASE_ADDON.compareAt)}`,
      };
    }

    return {
      primaryTitle: "Wheel",
      secondaryTitle: "Wheel + Base",
      primaryAria: "Wheel only",
      secondaryAria: `Add base to wheel for ${formatPrice(BASE_ADDON.price)}, was ${formatPrice(BASE_ADDON.compareAt)}`,
    };
  }

  // ─── Price helpers ───────────────────────────────────────────────────────────

  function formatPrice(n) {
    return "$" + n.toFixed(2);
  }

  function parsePagePrice(text) {
    if (!text) return 0;
    return parseFloat(text.replace(/[^0-9.]/g, "")) || 0;
  }

  function storeWheelPrices() {
    const salEl = document.querySelector("#chirpProductPrice strong.text-chirp-blue-dark");
    const cmpEl = document.querySelector("#chirpProductPrice s");

    if (salEl) wheelPrice = parsePagePrice(salEl.textContent);
    if (cmpEl) wheelCompareAt = parsePagePrice(cmpEl.textContent);
    if (!wheelCompareAt) wheelCompareAt = wheelPrice;

    document.querySelectorAll(".cw-wheel-price").forEach((el) => {
      if (!wheelPrice) return;
      el.innerHTML =
        wheelCompareAt > wheelPrice
          ? `<s>${formatPrice(wheelCompareAt)}</s>${formatPrice(wheelPrice)}`
          : formatPrice(wheelPrice);
    });
  }

  function updatePagePrice() {
    if (!wheelPrice) return;

    document.querySelectorAll("#chirpProductPrice strong.text-chirp-blue-dark").forEach((el) => {
      el.textContent =
        selectedOption === "with-base"
          ? formatPrice(Math.round((wheelPrice + BASE_ADDON.price) * 100) / 100)
          : formatPrice(wheelPrice);
    });

    document.querySelectorAll("#chirpProductPrice s").forEach((el) => {
      el.textContent =
        selectedOption === "with-base"
          ? formatPrice(Math.round((wheelCompareAt + BASE_ADDON.compareAt) * 100) / 100)
          : formatPrice(wheelCompareAt);
    });
  }

  // ─── Cart helpers ─────────────────────────────────────────────────────────────

  function getMainProductVariantId() {
    if (mainProductVariantId) return mainProductVariantId;

    const form = document.querySelector('form[action="/cart/add"]');
    if (form) {
      const v = form.querySelector('input[name="id"]');
      if (v) {
        mainProductVariantId = parseInt(v.value, 10);
        return mainProductVariantId;
      }
    }

    const sel = document.querySelector('select[name="id"]');
    if (sel) {
      mainProductVariantId = parseInt(sel.value, 10);
      return mainProductVariantId;
    }

    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      mainProductVariantId = window.ShopifyAnalytics.meta.selectedVariantId;
      return mainProductVariantId;
    }

    return null;
  }

  function openCartDrawer() {
    if (typeof CartManager !== "undefined") {
      const methods = ["openCart", "open", "showCart", "toggleCart"];
      for (const m of methods) {
        if (typeof CartManager[m] === "function") {
          CartManager[m]();
          return true;
        }
      }
    }

    if (typeof window.openCartDrawer === "function") {
      window.openCartDrawer();
      return true;
    }

    if (typeof window.openCart === "function") {
      window.openCart();
      return true;
    }

    const triggers = [
      '[data-cart-trigger]',
      '[data-action="open-cart"]',
      "[data-open-cart]",
      ".cart-icon-bubble",
      ".site-header__cart",
      ".header__icon--cart",
      ".js-cart-toggle",
      ".cart-toggle",
      "#cart-icon-bubble",
      'button[aria-controls="cart-drawer"]',
      '[aria-controls="CartDrawer"]',
    ];

    for (const s of triggers) {
      const el = document.querySelector(s);
      if (el) {
        el.click();
        return true;
      }
    }

    ["cart:open", "theme:cart:open", "cart-drawer:open"].forEach((e) => {
      document.dispatchEvent(new CustomEvent(e));
      window.dispatchEvent(new CustomEvent(e));
    });

    return false;
  }

  function addToCart() {
    const variantId = getMainProductVariantId();

    if (!variantId) {
      alert("Error: Could not find product variant. Please refresh and try again.");
      return Promise.reject("No variant ID");
    }

    const items = [{ id: variantId, quantity: 1 }];

    if (selectedOption === "with-base") {
      items.push({ id: BASE_ADDON.variantId, quantity: 1 });
    }

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("Add to cart failed");
        return r.json();
      })
      .then((data) => {
        if (typeof CartManager !== "undefined") {
          ["reloadCartCount", "reloadMainCart", "refresh", "updateCart"].forEach((m) => {
            if (typeof CartManager[m] === "function") CartManager[m]();
          });
        }

        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:item-added"));

        fetch("/cart.js")
          .then((r) => r.json())
          .then((cart) => {
            document
              .querySelectorAll(".cart-count, .cart-item-count, [data-cart-count], .header__cart-count")
              .forEach((el) => {
                el.textContent = cart.item_count;
              });
          });

        return data;
      });
  }

  // ─── Styles ──────────────────────────────────────────────────────────────────

  function injectStyles() {
    if (document.getElementById("cw-addon-styles")) return;

    const s = document.createElement("style");
    s.id = "cw-addon-styles";
    s.textContent = `
      .cw-addon{margin:16px 0;font-family:inherit;box-sizing:border-box}
      .cw-addon__label{font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#888;margin:0 0 10px;display:block}
      .cw-addon__options{display:grid;grid-template-columns:1fr 1fr;gap:8px}
      .cw-addon__option{position:relative;cursor:pointer;border-radius:12px;border:2px solid #e0e0e0;background:#fff;padding:10px;display:flex;flex-direction:row;align-items:center;gap:10px;transition:border-color .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent;user-select:none}
      .cw-addon__option:hover{border-color:#bbb;box-shadow:0 4px 12px rgba(0,0,0,.08)}
      .cw-addon__option.selected{border-color:#000;box-shadow:0 0 0 3px rgba(0,0,0,.08)}
      .cw-addon__option-img{width:72px;height:72px;object-fit:cover;border-radius:8px;background:#f5f5f5;flex-shrink:0}
      .cw-addon__option-body{display:flex;flex-direction:column;flex:1;min-width:0;gap:3px}
      .cw-addon__option-title{font-size:12px;font-weight:700;color:#111;line-height:1.3}
      .cw-addon__option-desc{font-size:11px;color:#777;line-height:1.4;display:none}
      .cw-addon__option-price{font-size:13px;font-weight:700;color:#111}
      .cw-addon__option-price s{font-weight:400;color:#aaa;margin-right:3px;font-size:11px}
      .cw-addon__option-badge{display:inline-block;background:#000;color:#fff;font-size:9px;font-weight:700;padding:2px 5px;border-radius:4px;letter-spacing:.4px;text-transform:uppercase;width:fit-content}
      @media(max-width:1350px){.cw-addon__options{grid-template-columns:1fr}}
    `;
    document.head.appendChild(s);
  }

  // ─── Render ───────────────────────────────────────────────────────────────────

  function getProductImage() {
    return document.querySelector('meta[property="og:image"]')?.content || "";
  }

  function createSelectorHTML() {
    const wheelImg = getProductImage();
    const copy = getOptionCopy();

    return `
      <div class="cw-addon" role="group" aria-label="Bundle options">
        <span class="cw-addon__label">Customise your experience</span>
        <div class="cw-addon__options">
          <div
            class="cw-addon__option selected"
            data-option="wheel-only"
            role="radio"
            tabindex="0"
            aria-checked="true"
            aria-label="${copy.primaryAria}"
          >
            ${wheelImg ? `<img class="cw-addon__option-img" src="${wheelImg}" alt="" aria-hidden="true">` : ""}
            <div class="cw-addon__option-body">
              <span class="cw-addon__option-title">${copy.primaryTitle}</span>
              <span class="cw-addon__option-desc"></span>
              <span class="cw-addon__option-price cw-wheel-price"></span>
            </div>
          </div>

          <div
            class="cw-addon__option"
            data-option="with-base"
            role="radio"
            tabindex="0"
            aria-checked="false"
            aria-label="${copy.secondaryAria}"
          >
            <img class="cw-addon__option-img" src="${BASE_ADDON.image}" alt="" onerror="this.style.display='none'" aria-hidden="true">
            <div class="cw-addon__option-body">
              <span class="cw-addon__option-badge">Save $20</span>
              <span class="cw-addon__option-title">${copy.secondaryTitle}</span>
              <span class="cw-addon__option-desc">${BASE_ADDON.description}</span>
              <span class="cw-addon__option-price"><s style="display:none;">${formatPrice(BASE_ADDON.compareAt)}</s>+ ${formatPrice(BASE_ADDON.price)}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  // ─── Selector logic ───────────────────────────────────────────────────────────

  function syncAllInstances() {
    if (!wheelPrice) storeWheelPrices();

    document.querySelectorAll("[data-cw-instance]").forEach((selector) => {
      selector.querySelectorAll(".cw-addon__option").forEach((b) => {
        const active = b.dataset.option === selectedOption;
        b.classList.toggle("selected", active);
        b.setAttribute("aria-checked", active ? "true" : "false");
      });
    });

    updatePagePrice();
  }

  function bindInstanceEvents(el) {
    el.querySelectorAll(".cw-addon__option").forEach((opt) => {
      const select = function () {
        selectedOption = opt.dataset.option;
        syncAllInstances();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "proteus_custom_event",
          proteus_event_name: `[CHRP-20] select: ${selectedOption}`,
          proteus_event_category: "CRO",
          page_location: window.location.href,
        });
      };

      opt.addEventListener("click", select);
      opt.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          select();
        }
      });
    });
  }

  function injectSelector() {
    let injectedAny = false;

    const mobileCta = document.getElementById("chirpProductCtaMobile");
    if (mobileCta && !mobileCta.querySelector("[data-cw-instance]")) {
      const d = document.createElement("div");
      d.innerHTML = createSelectorHTML();
      const el = d.firstElementChild;
      el.dataset.cwInstance = "mobile";

      const pf = mobileCta.querySelector("product-form");
      pf ? pf.parentNode.insertBefore(el, pf) : mobileCta.insertBefore(el, mobileCta.firstChild);

      bindInstanceEvents(el);
      injectedAny = true;
    }

    const desktopBuy = document.querySelector(".b-buy_buttons_hRqjym");
    if (desktopBuy && !desktopBuy.querySelector("[data-cw-instance]")) {
      const d = document.createElement("div");
      d.innerHTML = createSelectorHTML();
      const el = d.firstElementChild;
      el.dataset.cwInstance = "desktop";

      const pf = desktopBuy.querySelector("product-form");
      pf ? pf.parentNode.insertBefore(el, pf) : desktopBuy.insertBefore(el, desktopBuy.firstChild);

      bindInstanceEvents(el);
      injectedAny = true;
    }

    if (injectedAny) {
      storeWheelPrices();
      setTimeout(storeWheelPrices, 300);
      setTimeout(storeWheelPrices, 800);
      return true;
    }

    return false;
  }

  // ─── ATC intercept ────────────────────────────────────────────────────────────

  function handleATC(btn) {
    const prevHTML = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = "Adding…";

    addToCart()
      .then(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "proteus_custom_event",
          proteus_event_name: `[CHRP-20] ATC: ${selectedOption}`,
          proteus_event_category: "CRO",
          page_location: window.location.href,
        });

        btn.textContent = "Added!";

        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = prevHTML;
          openCartDrawer();
        }, 800);
      })
      .catch((err) => {
        console.error("[CHRP-20] Add to cart error:", err);
        btn.disabled = false;
        btn.innerHTML = prevHTML;
        alert("Failed to add to cart. Please try again.");
      });
  }

  function interceptAddToCart() {
    document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.cwIntercepted) return;
      form.dataset.cwIntercepted = "true";

      form
        .querySelectorAll('[type="submit"], .product-form__submit, button[name="add"], .add-to-cart, .btn-addtocart')
        .forEach((btn) => {
          if (btn.dataset.cwIntercepted) return;
          btn.dataset.cwIntercepted = "true";

          btn.addEventListener(
            "click",
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              handleATC(this);
            },
            true
          );
        });

      form.addEventListener(
        "submit",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const btn = form.querySelector('[type="submit"], .product-form__submit, button[name="add"]');
          if (btn) handleATC(btn);
        },
        true
      );
    });

    document
      .querySelectorAll('button[name="add"]:not([data-cw-intercepted]), .product-form__submit:not([data-cw-intercepted]), [data-add-to-cart]:not([data-cw-intercepted])')
      .forEach((btn) => {
        if (btn.closest("form[data-cw-intercepted]")) return;

        btn.dataset.cwIntercepted = "true";
        btn.addEventListener(
          "click",
          function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            handleATC(this);
          },
          true
        );
      });
  }

  // ─── Activate ─────────────────────────────────────────────────────────────────

  function activate() {
    if (window._chrp20_activated) return;

    const path = window.location.pathname;
    if (!PRODUCT_HANDLES.some((h) => path.includes(h))) return;

    window._chrp20_activated = true;
    selectedOption = "wheel-only";
    wheelPrice = 0;
    wheelCompareAt = 0;
    mainProductVariantId = null;

    getMainProductVariantId();
    injectStyles();

    if (!injectSelector()) {
      const observer = new MutationObserver(() => {
        if (injectSelector()) {
          observer.disconnect();
          interceptAddToCart();
          setTimeout(interceptAddToCart, 500);
          setTimeout(interceptAddToCart, 1500);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      interceptAddToCart();
      setTimeout(interceptAddToCart, 500);
      setTimeout(interceptAddToCart, 1500);
    }

    new MutationObserver((mutations) => {
      const shouldReintercept = mutations.some((m) =>
        [...m.addedNodes].some(
          (node) =>
            node.nodeType === 1 &&
            node.matches &&
            (node.matches('form[action*="/cart/add"]') || node.querySelector?.('form[action*="/cart/add"]'))
        )
      );

      if (shouldReintercept) setTimeout(interceptAddToCart, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.activate_chrp_20v1 = activate;
})();

// CHRP-22 - Unified Bundle Selector
(function () {
  "use strict";

  const PRODUCT_HANDLE = "chirp-halo-wireless-muscle-stim-double";
  const BUNDLE_IMAGE =
    "https://gochirp.com/cdn/shop/files/7-vert.jpg?v=1761770807&width=200";
  const MAIN_PRODUCT = {
    title: "Chirp Halo Wireless Muscle Stim",
    image:
      "https://gochirp.com/cdn/shop/files/7-vert.jpg?v=1761770807&width=400",
  };
  const BASE_PRICE = 159.99;
  const BASE_COMPARE_AT = 179.99;

  const PAD_INFO = {
    41597672095767: { title: "Ultimate Lower Back Relief", price: 16.99, description: "Contoured pads for optimal lower back coverage", image: "https://gochirp.com/cdn/shop/files/1-hero_e7b403c0-a1be-42bf-a0f8-25a37e255a5f.png?v=1762275695&width=200" },
    41597696409623: { title: "Ultimate Glute Relief", price: 15.99, description: "Large coverage pads for glute muscle stimulation", image: "https://gochirp.com/cdn/shop/files/1-hero_8c4f085f-83bd-431b-8e6b-d5f3b1b5c149.png?v=1722966235&width=200" },
    41597697720343: { title: "Ultimate Quad Relief", price: 15.99, description: "Elongated pads for quadricep muscle targeting", image: "https://gochirp.com/cdn/shop/files/1-hero_fcdef5aa-d313-43eb-85f5-383d1607dbdd.png?v=1722966355&width=200" },
    41597671079959: { title: "Ultimate Upper Back Relief", price: 16.99, description: "Wide pads for thoracic spine and upper back relief", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    41597674848279: { title: "Ultimate TFL/Hip Flexor Relief", price: 15.99, description: "Specialized pads for hip flexor and TFL targeting", image: "https://gochirp.com/cdn/shop/files/1-hero_e07c60da-5074-49ea-bce5-6ceeb8764787.png?v=1722964745&width=200" },
    42175501860887: { title: "Ultimate Trigger Point Relief", price: 18.99, description: "Small precision pads for targeted trigger point therapy", image: "https://gochirp.com/cdn/shop/files/1-chirp-halo-pads-triggerpoint-hero.png?v=1762277582&width=200" },
    41597674192919: { title: "Ultimate Trap Relief", price: 16.99, description: "Curved pads designed for trapezius muscle relief", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    41597672554519: { title: "Ultimate Shoulder Relief", price: 16.99, description: "Flexible pads for deltoid and shoulder coverage", image: "https://gochirp.com/cdn/shop/files/1-hero_f8b31f0e-9c81-4181-9243-97e129c3d36e.png?v=1762275694&width=200" },
    42902832021527: { title: "Ultimate Knee Relief", price: 18.99, description: "Contoured pads for around-knee muscle support", image: "https://gochirp.com/cdn/shop/files/1-hero_fcdef5aa-d313-43eb-85f5-383d1607dbdd.png?v=1722966355&width=200" },
    41597700079639: { title: "Ultimate Calf Relief", price: 15.99, description: "Wrap-around pads for calf muscle stimulation", image: "https://gochirp.com/cdn/shop/files/1-hero_2bbe88b9-0b98-4331-ba0a-5178b03995d9.png?v=1722966546&width=200" },
    42568201011223: { title: "Ultimate Menstrual Relief", price: 14.99, description: "Gentle pads designed for menstrual pain relief", image: "https://gochirp.com/cdn/shop/files/1-hero_5a9ef071-9085-468f-a331-b930b67d1728.png?v=1762278777&width=200" },
    42568177254423: { title: "Ultimate Foot Relief", price: 16.99, description: "Compact pads for plantar and foot muscle relief", image: "https://gochirp.com/cdn/shop/files/1-hero_458287f8-9b9f-4a8f-98a1-f804d49b9e62.png?v=1762278777&width=200" },
  };

  const BUNDLES_V1 = {
    title: "Choose Where You Need Relief",
    bundles: [
      { id: "device-only", title: "Basic Relief", isDeviceOnly: true, description: "", items: [] },
      { id: "upper-back", title: "Ultimate Upper Back Pain Relief", description: "Targeted pads for shoulders, traps, trigger points, and full back coverage", items: [{ quantity: 1, variantId: 41597672554519 },{ quantity: 1, variantId: 41597674192919 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597672095767 }] },
      { id: "lower-back", title: "Ultimate Lower Back Pain Relief", description: "Complete pad set for lower back pain and supporting muscle groups", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 41597696409623 },{ quantity: 1, variantId: 41597697720343 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597674848279 }] },
      { id: "neck", title: "Ultimate Neck Pain Relief", description: "Specialized pads for neck tension, traps, and cervical support", items: [{ quantity: 1, variantId: 41597672554519 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 2, variantId: 41597674192919 },{ quantity: 1, variantId: 41597671079959 }] },
    ],
  };

  const BUNDLES_V2 = {
    title: "Choose Targeted Relief Based on Your Life",
    bundles: [
      { id: "device-only", title: "Basic Relief", isDeviceOnly: true, description: "", items: [] },
      { id: "desk-job", title: "Desk Job Professional", description: "Perfect for office workers dealing with posture-related tension and sedentary lifestyle discomfort", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 41597674192919 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 42568177254423 }] },
      { id: "athlete", title: "Athlete / Fitness Enthusiast", description: "Optimize recovery and performance for active lifestyles", items: [{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 42902832021527 },{ quantity: 1, variantId: 42568177254423 }] },
      { id: "parent", title: "Parent", description: "Relief for the demands of parenting, lifting, carrying, and constant movement", items: [{ quantity: 1, variantId: 42902832021527 },{ quantity: 1, variantId: 41597671079959 },{ quantity: 1, variantId: 41597672095767 },{ quantity: 1, variantId: 42175501860887 },{ quantity: 1, variantId: 42568177254423 }] },
    ],
  };

  let activeConfig = null;
  let selectedBundle = null;
  let carouselPosition = 0;
  let currentPopupBundleIndex = 0;
  let mainProductVariantId = null;
  let previouslyFocusedElement = null;
  const ITEMS_VISIBLE_FALLBACK = 1.8, ITEM_GAP = 8;

  function getActualItemWidth(carousel) {
    const firstItem = carousel.querySelector(".halo-bundle-carousel__item");
    if (!firstItem) return 180;
    return firstItem.getBoundingClientRect().width;
  }

  function getItemsVisible(carousel) {
    const tw = carousel.querySelector(".halo-bundle-carousel__track-wrapper");
    if (!tw || tw.offsetWidth === 0) return ITEMS_VISIBLE_FALLBACK;
    const itemWidth = getActualItemWidth(carousel);
    if (itemWidth === 0) return ITEMS_VISIBLE_FALLBACK;
    return (tw.offsetWidth + ITEM_GAP) / (itemWidth + ITEM_GAP);
  }

  function getVariantImage(variantId) {
    const p = PAD_INFO[variantId];
    return p && p.image ? p.image : BUNDLE_IMAGE;
  }

  function getMainProductVariantId() {
    if (mainProductVariantId) return mainProductVariantId;
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) { const v = form.querySelector('input[name="id"]'); if (v) { mainProductVariantId = parseInt(v.value, 10); return mainProductVariantId; } }
    const sel = document.querySelector('select[name="id"]');
    if (sel) { mainProductVariantId = parseInt(sel.value, 10); return mainProductVariantId; }
    if (window.ShopifyAnalytics?.meta?.selectedVariantId) { mainProductVariantId = window.ShopifyAnalytics.meta.selectedVariantId; return mainProductVariantId; }
    return null;
  }

  function openCartDrawer() {
    if (typeof CartManager !== "undefined") {
      if (typeof CartManager.openCart === "function") { CartManager.openCart(); return true; }
      if (typeof CartManager.open === "function") { CartManager.open(); return true; }
      if (typeof CartManager.showCart === "function") { CartManager.showCart(); return true; }
      if (typeof CartManager.toggleCart === "function") { CartManager.toggleCart(); return true; }
    }
    if (typeof window.openCartDrawer === "function") { window.openCartDrawer(); return true; }
    if (typeof window.openCart === "function") { window.openCart(); return true; }
    if (typeof window.CartDrawer !== "undefined" && typeof window.CartDrawer.open === "function") { window.CartDrawer.open(); return true; }
    if (typeof window.Shopify !== "undefined" && window.Shopify.CartDrawer && typeof window.Shopify.CartDrawer.open === "function") { window.Shopify.CartDrawer.open(); return true; }
    const triggers = ["[data-cart-trigger]",'[data-action="open-cart"]',"[data-open-cart]",".cart-icon-bubble",".site-header__cart",".header__icon--cart",".js-cart-toggle",".cart-toggle",".cart-btn","#cart-icon-bubble",'a[href="/cart"].header__icon','button[aria-controls="cart-drawer"]','[aria-controls="CartDrawer"]',".header-cart-btn",".mini-cart-trigger"];
    for (const s of triggers) { const el = document.querySelector(s); if (el) { el.click(); return true; } }
    ["cart:open","theme:cart:open","cart-drawer:open","open-cart"].forEach((e) => { document.dispatchEvent(new CustomEvent(e)); window.dispatchEvent(new CustomEvent(e)); });
    const drawers = ["#CartDrawer","#cart-drawer",".cart-drawer",".mini-cart",".side-cart","[data-cart-drawer]",".drawer--cart"];
    for (const s of drawers) { const d = document.querySelector(s); if (d) { d.classList.add("is-open","active","open","is-active"); d.setAttribute("aria-hidden","false"); const o = document.querySelector(".drawer-overlay, .cart-overlay, .site-overlay"); if (o) o.classList.add("is-visible","active"); document.body.classList.add("cart-open","drawer-open","overflow-hidden"); return true; } }
    return false;
  }

  // Returns { price, compareAt } — compareAt includes original base price + full pad prices
  function calculateBundlePrice(b) {
    if (!b || b.isDeviceOnly) {
      return { price: BASE_PRICE, compareAt: BASE_COMPARE_AT };
    }
    let discountedPadsTotal = 0;
    let fullPadsTotal = 0;
    b.items.forEach((item) => {
      const padInfo = PAD_INFO[item.variantId];
      if (padInfo) {
        const discountedPadPrice = Math.round(padInfo.price * 0.8 * 100) / 100;
        discountedPadsTotal += discountedPadPrice * item.quantity;
        fullPadsTotal += padInfo.price * item.quantity;
      }
    });
    return {
      price: Math.round((BASE_PRICE + discountedPadsTotal) * 100) / 100,
      compareAt: Math.round((BASE_COMPARE_AT + fullPadsTotal) * 100) / 100,
    };
  }

  function formatPrice(a) {
    return "$" + a.toFixed(2);
  }

  // Returns HTML: strikethrough compare-at + sale price in red
  function formatPriceWithCompare(price, compareAt) {
    if (compareAt > price) {
      return '<span class="halo-price-compare">' + formatPrice(compareAt) + '</span> <span class="halo-price-sale">' + formatPrice(price) + '</span>';
    }
    return '<span class="halo-price-sale">' + formatPrice(price) + '</span>';
  }

  // Helper for the popup add-to-cart button text (white strikethrough on dark bg)
  function formatAddBtnPrice(price, compareAt) {
    if (compareAt > price) {
      return 'Add to Cart - <span style="text-decoration:line-through;opacity:.6;font-weight:400;margin-right:4px;">' + formatPrice(compareAt) + '</span> ' + formatPrice(price);
    }
    return 'Add to Cart - ' + formatPrice(price);
  }

  function updatePrice(b) {
    const { price, compareAt } = calculateBundlePrice(b);
    // Only update the sale price text — the site already renders its own compare-at strikethrough
    ["#chirpProductPrice strong.text-chirp-blue-dark",".product__price .price-item--regular",".product-single__price","[data-product-price]"].forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) el.textContent = formatPrice(price);
    });
    // Also update the site's native compare-at price if present
    ["#chirpProductPrice .text-chirp-gray-medium s","#chirpProductPrice s",".product__price .price-item--sale s",".compare-at-price"].forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) el.textContent = formatPrice(compareAt);
    });
  }

  function selectBundle(id) {
    document.querySelectorAll(".halo-bundle-carousel__item").forEach((el) => {
      const s = el.dataset.bundleId === id;
      el.classList.toggle("selected", s);
      el.setAttribute("aria-pressed", s ? "true" : "false");
    });
    selectedBundle = activeConfig.bundles.find((b) => b.id === id) || activeConfig.bundles[0];
    updatePrice(selectedBundle);
    announceToScreenReader("Selected " + selectedBundle.title + " bundle");
  }

  function addToCart(bundle) {
    const variantId = getMainProductVariantId();
    if (!variantId) { console.error("Could not find main product variant ID"); alert("Error: Could not add to cart. Please try the main Add to Cart button."); return Promise.reject("No variant ID"); }
    const items = [{ id: variantId, quantity: 1 }];
    if (bundle && !bundle.isDeviceOnly && bundle.items && bundle.items.length > 0) { bundle.items.forEach((item) => { items.push({ id: item.variantId, quantity: item.quantity }); }); }
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) })
      .then((r) => { if (!r.ok) throw new Error("Add to cart failed"); return r.json(); })
      .then((data) => {
        if (typeof CartManager !== "undefined") { ["reloadCartCount","reloadMainCart","refresh","updateCart"].forEach((m) => { if (typeof CartManager[m] === "function") CartManager[m](); }); }
        document.dispatchEvent(new CustomEvent("cart:updated"));
        document.dispatchEvent(new CustomEvent("cart:item-added"));
        fetch("/cart.js").then((r) => r.json()).then((cart) => { document.querySelectorAll(".cart-count, .cart-item-count, [data-cart-count], .header__cart-count").forEach((el) => { el.textContent = cart.item_count; }); });
        return data;
      });
  }

  function announceToScreenReader(msg) {
    let a = document.getElementById("halo-sr-announcer");
    if (!a) { a = document.createElement("div"); a.id = "halo-sr-announcer"; a.setAttribute("aria-live","polite"); a.setAttribute("aria-atomic","true"); a.className = "halo-sr-only"; document.body.appendChild(a); }
    a.textContent = "";
    setTimeout(() => { a.textContent = msg; }, 100);
  }

  function injectStyles() {
    if (document.getElementById("halo-bundle-styles-22")) return;
    const s = document.createElement("style");
    s.id = "halo-bundle-styles-22";
    s.textContent = '.halo-price-compare{text-decoration:line-through;color:#999;font-weight:400;font-size:.85em;margin-right:4px}.halo-price-sale{color:#e53e3e;font-weight:700}.halo-popup__main-product-price .halo-price-compare{font-size:13px}.halo-popup__main-product-price .halo-price-sale{font-size:15px;color:#e53e3e}.halo-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}.halo-bundle-carousel__container,.halo-bundle-carousel__item{box-sizing:border-box;position:relative}.halo-bundle-carousel{margin:1rem 0;width:100%;box-sizing:border-box}.halo-bundle-carousel__title{color:#0b0f14;font-weight:700}.halo-bundle-carousel__track-wrapper{display:grid;width:100%;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;padding:8px 0;scroll-snap-type:x mandatory;scroll-padding-inline-start:4px}.halo-bundle-carousel__track-wrapper::-webkit-scrollbar{display:none}.halo-bundle-carousel__track{display:flex;padding:0 4px;gap:8px}.halo-bundle-carousel__item{flex:0 0 180px;padding:8px;gap:8px;cursor:pointer;transition:transform .15s,box-shadow .15s,border-color .15s;background:#fff;display:flex;flex-direction:row;align-items:flex-start;scroll-snap-align:start;border:1px solid #c6c6c6;border-radius:20px;box-shadow:0 5px 5px rgb(10 20 30 / .06);flex-wrap:wrap}.halo-bundle-carousel__item:hover{transform:translateY(-2px);box-shadow:0 8px 4px rgb(10 20 30 / .1)}.halo-bundle-carousel__item:focus-visible{outline:#000 solid 3px;outline-offset:2px}.halo-bundle-carousel__item.selected{border-color:rgb(139 141 145 / 1);box-shadow:0 0 0 4px rgb(139 141 145 / .32),0 6px 2px rgb(10 20 30 / .12)}.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-description,.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-price,.halo-bundle-carousel__item.selected .halo-bundle-carousel__item-title{color:#1a1a1a}.halo-bundle-carousel__item.selected .halo-bundle-carousel__more-info{box-shadow:0 12px 26px rgb(35 110 249 / .28)}.halo-bundle-carousel__item-image-wrap{flex:0 0 34%;aspect-ratio:10/10;border-radius:14px;border:1px solid #e6ebf0;background:#f7fafc;overflow:hidden}.halo-bundle-carousel__item-image{width:100%;height:100%;object-fit:cover}.halo-bundle-carousel__item-content{display:grid}.halo-bundle-carousel__item-title{color:#1a1a1a;font-size:12px;font-weight:600;margin:0 0 4px;line-height:1.2;white-space:wrap;overflow:hidden}.halo-bundle-carousel__item-price{color:#1a1a1a;font-size:13px;font-weight:700;margin:0 0 4px}.halo-bundle-carousel__item-description{font-size:11px;margin:0;color:#5b6672;display:flex;gap:8px;align-items:center}.halo-bundle-carousel__item-description:not(:empty)::before{content:"";width:8px;height:8px;border-radius:50%;background:#236ef9;box-shadow:0 0 0 3px rgb(35 110 249 / .16)}.halo-bundle-carousel__savings-badge{display:none;position:absolute;top:-6px;left:-6px;background:linear-gradient(135deg,#22c55e 0,#16a34a 100%);color:#fff;font-size:9px;font-weight:700;padding:3px 6px;border-radius:4px;white-space:nowrap;box-shadow:0 2px 4px rgb(0 0 0 / .15);z-index:5;text-transform:uppercase;letter-spacing:.3px}.halo-bundle-carousel__more-info{font-size:12px;width:100%;line-height:0;padding:13px;border-radius:20px;border:1px solid #fff0;background:#236ef9;color:#fff;font-weight:600;cursor:pointer;display:grid;place-items:center;transition:background .15s,transform .15s,box-shadow .15s;align-self:end}.halo-bundle-carousel__more-info:hover{background:#154fba;box-shadow:0 10px 22px rgb(35 110 249 / .22)}.halo-bundle-carousel__dot:hover,.halo-popup__switcher-dot:hover:not(.active){background:#bbb}.halo-bundle-carousel__more-info:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__nav{width:44px;height:44px;border-radius:50%;background:#fff;border:1px solid #c6c6c6;cursor:pointer;display:grid;place-items:center;z-index:10;transition:transform .15s,box-shadow .15s,border-color .15s}.halo-bundle-carousel__nav:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__nav:disabled{opacity:.4;cursor:not-allowed;box-shadow:none}.halo-bundle-carousel__nav svg{width:22px;height:22px;fill:#0b0f14}.halo-bundle-carousel__dots{display:flex;justify-content:center;gap:8px;margin-top:2px}.halo-bundle-carousel__dot{position:relative;width:8px;height:8px;border-radius:50%;border:1px solid #c6c6c6;background:#eee;opacity:.9;cursor:pointer;transition:width .15s,background .15s,border-color .15s}.halo-popup,.halo-popup-overlay{position:fixed;opacity:0;visibility:hidden}.halo-bundle-carousel__dot::before{content:"";position:absolute;top:-6px;right:-6px;bottom:-6px;left:-6px}.halo-bundle-carousel__dot:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-bundle-carousel__dot.active{background:#3473e8;border-color:#154fba}.halo-popup-overlay{top:0;left:0;right:0;bottom:0;background:rgb(0 0 0 / .6);backdrop-filter:blur(4px);z-index:9999;transition:.3s}.halo-popup-overlay.active{opacity:1;visibility:visible}.halo-popup{top:50%;left:50%;transform:translate(-50%,-50%) scale(.95);background:#fff;border-radius:20px;width:92%;max-width:560px;max-height:90vh;overflow:hidden;box-shadow:0 25px 60px -12px rgb(0 0 0 / .3);z-index:10000;transition:.3s cubic-bezier(.4, 0, .2, 1);display:flex;flex-direction:column}.halo-popup-overlay.active .halo-popup{opacity:1;visibility:visible;transform:translate(-50%,-50%) scale(1)}.halo-popup__header{display:flex;flex-direction:column;align-items:center;padding:20px 16px;border-bottom:1px solid #eee;background:#fff;flex-shrink:0;position:relative}.halo-popup__close:hover,.halo-popup__switcher-btn:hover:not(:disabled){border-color:rgb(0 0 0 / .3)}.halo-popup__title-wrap{text-align:center;min-width:0;width:100%;padding:0 50px}.halo-popup__title{font-size:22px;font-weight:700;color:#1a1a1a;margin:0 0 6px;line-height:1.2}.halo-popup__subtitle{font-size:14px;color:#666;margin:0 0 12px;line-height:1.4}.halo-popup__nav-row{display:flex;align-items:center;justify-content:center;gap:16px;width:100%}.halo-popup__switcher-dots{display:flex;gap:8px;justify-content:center}.halo-popup__switcher-dot{width:10px;height:10px;border-radius:50%;background:#ddd;border:none;padding:0;cursor:pointer;transition:.2s;position:relative}.halo-popup__close,.halo-popup__switcher-btn{width:44px;height:44px;background:#fff;cursor:pointer}.halo-popup__close,.halo-popup__item,.halo-popup__switcher-btn{transition:border-color .2s;display:flex}.halo-popup__switcher-dot::before{content:"";position:absolute;top:-8px;right:-8px;bottom:-8px;left:-8px}.halo-popup__switcher-dot:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__switcher-dot.active{background:#000}.halo-popup__switcher-btn{border-radius:50%;border:2px solid;align-items:center;justify-content:center;flex-shrink:0}.halo-popup__switcher-btn:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__switcher-btn:disabled{opacity:.35;cursor:not-allowed}.halo-popup__switcher-btn svg{width:18px;height:18px;fill:#333}.halo-popup__close{border-radius:50%;border:2px solid;align-items:center;justify-content:center;flex-shrink:0;position:absolute;top:16px;right:16px}.halo-popup__close:focus-visible{outline:#000 solid 2px;outline-offset:2px}.halo-popup__close svg{width:20px;height:20px;fill:#666}.halo-popup__body{padding:24px;overflow-y:auto;flex:1}.halo-popup__section{margin-bottom:24px}.halo-popup__section:last-child{margin-bottom:0}.halo-popup__section-title{font-size:12px;font-weight:700;color:#888;text-transform:uppercase;letter-spacing:.8px;margin:0 0 14px;display:flex;align-items:center;gap:12px}.halo-popup__section-title::after{content:"";flex:1;height:1px;background:#eee}.halo-popup__main-product{display:flex;gap:16px;padding:8px;background:#fafafa;border-radius:10px;border:2px solid}.halo-popup__main-product-image{width:80px;height:80px;object-fit:contain;border-radius:10px;background:#fff;padding:8px;flex-shrink:0}.halo-popup__main-product-info{flex:1;min-width:0}.halo-popup__main-product-title{font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 4px;line-height:1.3}.halo-popup__main-product-price{font-size:15px;font-weight:700;color:#1a1a1a;margin:0 0 6px}.halo-popup__savings-banner{background:#edf979;color:#012287;padding:10px 14px;border-radius:8px;margin-bottom:14px;display:flex;align-items:center;gap:8px;font-size:13px;font-weight:600}.halo-popup__savings-banner svg{width:18px;height:18px;fill:#012287;flex-shrink:0}.halo-popup__items-list{display:flex;flex-direction:column;gap:10px}.halo-popup__item{gap:14px;padding:4px;background:#fff;border-radius:10px;border:2px solid}.halo-popup__item:hover{border-color:rgb(0 0 0 / .2)}.halo-popup__item-image{width:52px;height:52px;object-fit:contain;border-radius:8px;background:#fff;flex-shrink:0;border:1px solid #eee}.halo-popup__item-info{flex:1;min-width:0;display:flex;flex-direction:column;justify-content:center}.halo-popup__item-row{display:flex;justify-content:space-between;align-items:center;gap:12px}.halo-popup__item-title{font-size:14px;font-weight:600;color:#1a1a1a;margin:0;line-height:1.3}.halo-popup__item-qty{font-size:13px;color:#000;font-weight:600;background:#f0f0f0;padding:4px 10px;border-radius:12px;white-space:nowrap}.halo-popup__item-desc{font-size:12px;color:#666;margin:6px 0 0;line-height:1.4}.halo-popup__footer{border-top:1px solid #eee;background:#fafafa;flex-shrink:0}.halo-popup__cart-section{padding:18px 24px;display:flex;align-items:center;justify-content:center}.halo-popup__add-btn{padding:16px 32px;background:#000;color:#fff;border:none;border-radius:10px;font-size:16px;font-weight:600;cursor:pointer;transition:background .2s;white-space:nowrap;min-height:52px}.halo-popup__add-btn:hover{background:#333}.halo-popup__add-btn:focus-visible{outline:#000 solid 3px;outline-offset:3px}.halo-popup__add-btn:disabled{background:#ccc;cursor:not-allowed}.halo-popup__add-btn--loading{pointer-events:none}.halo-popup__add-btn--loading::after{content:"";display:inline-block;width:16px;height:16px;border:2px solid #fff0;border-top-color:#fff;border-radius:50%;animation:.8s linear infinite halo-spin;margin-left:10px;vertical-align:middle}@keyframes halo-spin{to{transform:rotate(360deg)}}.halo-bundle-carousel-desktop-wrapper{display:none}@media (min-width:1024px){.halo-bundle-carousel-desktop-wrapper{display:flex}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel{margin:0 auto}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__container{display:grid;grid-template-columns:44px 1fr 44px;align-items:center;gap:4px;max-width:612px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__title{text-align:center;line-height:1.1;font-size:14px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item{flex:0 0 250px}.halo-bundle-carousel__item.selected{box-shadow:0 0 0 4px rgb(139 141 145 / .52),0 6px 2px rgb(10 20 30 / .22)}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-content{flex:0 0 50%}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-price{font-size:1rem}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__item-description{font-size:12px}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__savings-badge{font-size:8px;padding:2px 5px;top:-5px;left:-5px}#chirpProductCta{width:auto;max-width:none}#chirpProductCta .product-form__submit{min-height:55px;height:auto!important}#chirpProductPrice{gap:0;flex-direction:column}.halo-bundle-carousel-desktop-wrapper .halo-bundle-carousel__nav:hover:not(:disabled){transform:translateY(-1px);border-color:rgb(35 110 249 / .45);box-shadow:0 12px 28px rgb(10 20 30 / .12)}}@media (max-width:480px){.halo-popup{width:95%;max-height:92vh}.halo-popup__close,.halo-popup__switcher-btn{width:40px;height:40px}.halo-popup__header{padding:20px 14px}.halo-popup__title{font-size:20px}.halo-popup__subtitle{font-size:13px}.halo-popup__close{top:12px;right:12px}.halo-popup__body{padding:18px}.halo-popup__main-product{flex-direction:row;align-items:center;text-align:center;padding:8px}.halo-popup__main-product-image{width:90px;height:90px}.halo-popup__cart-section{padding:16px 18px}.halo-popup__add-btn{width:100%;padding:18px}.halo-bundle-carousel__container{padding:0 40px}.halo-bundle-carousel__item{flex-direction:column}.halo-bundle-carousel__item-image-wrap{flex:0 0 auto}.halo-bundle-carousel__title{margin-bottom:5px;font-size:1rem}.halo-bundle-carousel__item-price{font-size:1rem}.halo-bundle-carousel__item-description{font-size:12px}.halo-bundle-carousel__more-info{margin-top:auto}.halo-bundle-carousel__nav{position:absolute;top:50%;transform:translateY(-50%)}.halo-bundle-carousel__nav--prev{left:-13px}.halo-bundle-carousel__nav--next{right:-13px}.halo-bundle-carousel__dots{margin-top:15px}}@media (prefers-reduced-motion:reduce){.halo-bundle-carousel__dot,.halo-bundle-carousel__item,.halo-bundle-carousel__more-info,.halo-bundle-carousel__nav,.halo-bundle-carousel__track,.halo-popup,.halo-popup-overlay,.halo-popup__add-btn,.halo-popup__close,.halo-popup__item,.halo-popup__switcher-btn,.halo-popup__switcher-dot{transition:none!important;animation:none!important}}'
    document.head.appendChild(s);
  }
  
  function getMaxPosition(carousel) {
    const itemsVisible = carousel ? getItemsVisible(carousel) : ITEMS_VISIBLE_FALLBACK;
    return Math.max(0, Math.ceil(activeConfig.bundles.length - itemsVisible));
  }

  function updateDots(carousel) {
    const dotsContainer = carousel.querySelector(".halo-bundle-carousel__dots");
    if (!dotsContainer) return;
    const max = getMaxPosition(carousel);
    const total = max + 1;
    if (carouselPosition > max) carouselPosition = max;
    let h = "";
    for (let i = 0; i < total; i++) { const isActive = i === carouselPosition; h += '<button class="halo-bundle-carousel__dot' + (isActive ? " active" : "") + '" data-position="' + i + '" aria-label="Go to slide ' + (i + 1) + " of " + total + '"' + (isActive ? ' aria-current="true"' : "") + "></button>"; }
    dotsContainer.innerHTML = h;
    dotsContainer.querySelectorAll(".halo-bundle-carousel__dot").forEach((dot) => { dot.addEventListener("click", (e) => { e.preventDefault(); const pos = parseInt(dot.dataset.position, 10); if (!isNaN(pos) && pos !== carouselPosition) { carouselPosition = pos; updateAllCarousels(); } }); });
  }

  function createDotsHTML() { return ""; }

  function createCarouselHTML() {
    const usedImages = new Set();
    const itemsHTML = activeConfig.bundles.map((b, idx) => {
      const { price, compareAt } = calculateBundlePrice(b);
      const priceHTML = formatPriceWithCompare(price, compareAt);
      const moreBtn = '<button class="halo-bundle-carousel__more-info" data-bundle-index="' + idx + '" aria-label="View details for ' + b.title + ' bundle">View details</button>';
      let img = BUNDLE_IMAGE;
      if (!b.isDeviceOnly && b.items.length > 0) {
        const bundleImages = b.items.map(item => getVariantImage(item.variantId));
        const available = bundleImages.filter(i => !usedImages.has(i));
        const pool = available.length > 0 ? available : bundleImages;
        img = pool[Math.floor(Math.random() * pool.length)];
        usedImages.add(img);
      }
      const isFirst = idx === 0;
      const selectedClass = isFirst ? " selected" : "";
      const ariaPressed = isFirst ? "true" : "false";
      const savingsBadge = !b.isDeviceOnly ? '<span class="halo-bundle-carousel__savings-badge">Save 20%</span>' : "";

      if (b.isDeviceOnly) {
        return '<div class="halo-bundle-carousel__item halo-bundle-carousel__item--device-only' + selectedClass + '" data-bundle-id="' + b.id + '" data-bundle-index="' + idx + '" role="button" tabindex="0" aria-pressed="' + ariaPressed + '" aria-label="' + b.title + ", " + formatPrice(price) + ', device only with no pads"><div class="halo-bundle-carousel__item-image-wrap"><img class="halo-bundle-carousel__item-image" src="' + BUNDLE_IMAGE + '" alt="" aria-hidden="true"></div><div class="halo-bundle-carousel__item-content"><p class="halo-bundle-carousel__item-title">' + b.title + '</p><p class="halo-bundle-carousel__item-price">' + priceHTML + '</p><p class="halo-bundle-carousel__item-description"></p></div>' + moreBtn + "</div>";
      }
      const cnt = b.items.reduce((s, i) => s + i.quantity, 0);
      return '<div class="halo-bundle-carousel__item' + selectedClass + '" data-bundle-id="' + b.id + '" data-bundle-index="' + idx + '" role="button" tabindex="0" aria-pressed="' + ariaPressed + '" aria-label="' + b.title + " bundle, " + formatPrice(price) + ", includes " + cnt + ' pad sets, save 20% on pads"><div class="halo-bundle-carousel__item-image-wrap">' + savingsBadge + '<img class="halo-bundle-carousel__item-image" src="' + img + '" alt="" aria-hidden="true"></div><div class="halo-bundle-carousel__item-content"><p class="halo-bundle-carousel__item-title">' + b.title + '</p><p class="halo-bundle-carousel__item-price">' + priceHTML + '</p><p class="halo-bundle-carousel__item-description">' + cnt + " pads included</p></div>" + moreBtn + "</div>";
    }).join("");

    return '<div class="halo-bundle-carousel" role="region" aria-label="Bundle selection carousel"><h3 class="halo-bundle-carousel__title" id="halo-carousel-heading">' + activeConfig.title + '</h3><div class="halo-bundle-carousel__container"><button class="halo-bundle-carousel__nav halo-bundle-carousel__nav--prev" disabled aria-label="Previous bundles"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button><div class="halo-bundle-carousel__track-wrapper"><div class="halo-bundle-carousel__track" role="listbox" aria-labelledby="halo-carousel-heading">' + itemsHTML + '</div></div><button class="halo-bundle-carousel__nav halo-bundle-carousel__nav--next" aria-label="Next bundles"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg></button></div><div class="halo-bundle-carousel__dots" role="tablist" aria-label="Carousel pagination">' + createDotsHTML() + "</div></div>";
  }

  function createPopupHTML() {
    return '<div class="halo-popup-overlay" id="haloBundlePopup" role="dialog" aria-modal="true" aria-labelledby="popupTitle" aria-describedby="popupSubtitle"><div class="halo-popup"><div class="halo-popup__header"><div class="halo-popup__title-wrap"><h2 class="halo-popup__title" id="popupTitle">What\'s Included</h2><p class="halo-popup__subtitle" id="popupSubtitle">Bundle details</p></div><div class="halo-popup__nav-row"><button class="halo-popup__switcher-btn" id="popupPrev" aria-label="Previous bundle"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg></button><div class="halo-popup__switcher-dots" id="popupDots" role="tablist" aria-label="Bundle navigation"></div><button class="halo-popup__switcher-btn" id="popupNext" aria-label="Next bundle"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg></button></div><button class="halo-popup__close" id="popupClose" aria-label="Close dialog"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></button></div><div class="halo-popup__body" id="popupBody"></div><div class="halo-popup__footer"><div class="halo-popup__cart-section"><button class="halo-popup__add-btn" id="popupAddBtn">Add to Cart</button></div></div></div></div>';
  }

  function updatePopupContent(idx) {
    const b = activeConfig.bundles[idx];
    if (!b) return;
    currentPopupBundleIndex = idx;

    document.getElementById("popupTitle").textContent = b.title + (b.isDeviceOnly ? "" : " Bundle");
    document.getElementById("popupSubtitle").textContent = b.description;

    const { price: bp, compareAt: bCompare } = calculateBundlePrice(b);
    document.getElementById("popupAddBtn").innerHTML = formatAddBtnPrice(bp, bCompare);

    const body = document.getElementById("popupBody");
    const mainPriceHTML = formatPriceWithCompare(BASE_PRICE, BASE_COMPARE_AT);
    const mainHTML = '<div class="halo-popup__section"><p class="halo-popup__section-title">Main Device</p><div class="halo-popup__main-product"><img class="halo-popup__main-product-image" src="' + MAIN_PRODUCT.image + '" alt="' + MAIN_PRODUCT.title + '"><div class="halo-popup__main-product-info"><h3 class="halo-popup__main-product-title">' + MAIN_PRODUCT.title + '</h3><p class="halo-popup__main-product-price">' + mainPriceHTML + '</p></div></div></div>';

    if (b.isDeviceOnly) {
      body.innerHTML = mainHTML + '<div style="display:none;"></div>';
    } else {
      const cnt = b.items.reduce((s, i) => s + i.quantity, 0);
      const totalSavings = Math.round((bCompare - bp) * 100) / 100;
      const savingsBanner = '<div class="halo-popup__savings-banner"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>You save ' + formatPrice(totalSavings) + ' with this bundle!</div>';
      const iHTML = b.items.map((i) => { const p = PAD_INFO[i.variantId] || { title: "Pad Set", description: "" }; const img = getVariantImage(i.variantId); return '<div class="halo-popup__item"><img class="halo-popup__item-image" src="' + img + '" alt="' + p.title + '"><div class="halo-popup__item-info"><div class="halo-popup__item-row"><h4 class="halo-popup__item-title">' + p.title + '</h4><span class="halo-popup__item-qty">\u00d7' + i.quantity + '</span></div><p class="halo-popup__item-desc">' + p.description + '</p></div></div>'; }).join("");
      body.innerHTML = mainHTML + '<div class="halo-popup__section"><p class="halo-popup__section-title">Included Pad Sets (' + cnt + ')</p>' + savingsBanner + '<div class="halo-popup__items-list">' + iHTML + '</div></div>';
    }

    const dc = document.getElementById("popupDots");
    dc.innerHTML = activeConfig.bundles.map((x, i) => '<button class="halo-popup__switcher-dot' + (i === idx ? " active" : "") + '" data-index="' + i + '" aria-label="View ' + x.title + ' bundle"' + (i === idx ? ' aria-current="true"' : "") + '></button>').join("");
    document.getElementById("popupPrev").disabled = idx === 0;
    document.getElementById("popupNext").disabled = idx === activeConfig.bundles.length - 1;
    dc.querySelectorAll(".halo-popup__switcher-dot").forEach((d) => { d.addEventListener("click", () => updatePopupContent(parseInt(d.dataset.index, 10))); });
  }

  function openPopup(idx) {
    previouslyFocusedElement = document.activeElement;
    let popup = document.getElementById("haloBundlePopup");
    if (!popup) {
      document.body.insertAdjacentHTML("beforeend", createPopupHTML());
      popup = document.getElementById("haloBundlePopup");
      document.getElementById("popupClose").addEventListener("click", closePopup);
      popup.addEventListener("click", (e) => { if (e.target === popup) closePopup(); });
      document.getElementById("popupPrev").addEventListener("click", () => { if (currentPopupBundleIndex > 0) updatePopupContent(currentPopupBundleIndex - 1); });
      document.getElementById("popupNext").addEventListener("click", () => { if (currentPopupBundleIndex < activeConfig.bundles.length - 1) updatePopupContent(currentPopupBundleIndex + 1); });

      document.getElementById("popupAddBtn").addEventListener("click", function () {
        const btn = this;
        const b = activeConfig.bundles[currentPopupBundleIndex];
        const { price: bp, compareAt: bCompare } = calculateBundlePrice(b);
        btn.disabled = true;
        btn.classList.add("halo-popup__add-btn--loading");
        btn.textContent = "Adding";
        addToCart(b).then(() => {
          // console.log("BUNDLE ADDED", b);

          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            'event': 'proteus_custom_event',
            'proteus_event_name': `[CHRP-22] ATC: ${b.id}`,
            'proteus_event_category': "CRO",
            'page_location': window.location.href
          });

          btn.textContent = "Added!";
          btn.classList.remove("halo-popup__add-btn--loading");
          selectBundle(b.id);
          announceToScreenReader(b.title + " bundle added to cart");
          setTimeout(() => { closePopup(); btn.disabled = false; btn.innerHTML = formatAddBtnPrice(bp, bCompare); setTimeout(() => { openCartDrawer(); }, 300); }, 600);
        }).catch((e) => {
          console.error("Add to cart error:", e);
          btn.disabled = false;
          btn.classList.remove("halo-popup__add-btn--loading");
          btn.innerHTML = formatAddBtnPrice(bp, bCompare);
          alert("Failed to add to cart. Please try again.");
        });
      });

      document.addEventListener("keydown", handlePopupKeydown);
    }
    updatePopupContent(idx);
    popup.classList.add("active");
    document.body.style.overflow = "hidden";
    setTimeout(() => { document.getElementById("popupClose").focus(); }, 100);
  }

  function handlePopupKeydown(e) {
    const p = document.getElementById("haloBundlePopup");
    if (!p || !p.classList.contains("active")) return;
    if (e.key === "Escape") closePopup();
    else if (e.key === "ArrowLeft" && currentPopupBundleIndex > 0) updatePopupContent(currentPopupBundleIndex - 1);
    else if (e.key === "ArrowRight" && currentPopupBundleIndex < activeConfig.bundles.length - 1) updatePopupContent(currentPopupBundleIndex + 1);
    else if (e.key === "Tab") {
      const f = p.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function closePopup() {
    const p = document.getElementById("haloBundlePopup");
    if (p) { p.classList.remove("active"); document.body.style.overflow = ""; if (previouslyFocusedElement) { previouslyFocusedElement.focus(); previouslyFocusedElement = null; } }
  }

  function updateCarousel(c, animate = true) {
    const tw = c.querySelector(".halo-bundle-carousel__track-wrapper");
    const pb = c.querySelector(".halo-bundle-carousel__nav--prev");
    const nb = c.querySelector(".halo-bundle-carousel__nav--next");
    if (!tw) return;
    if (tw.offsetWidth === 0) return;
    const max = getMaxPosition(c);
    if (carouselPosition > max) carouselPosition = max;
    const itemWidth = getActualItemWidth(c);
    const step = itemWidth + ITEM_GAP;
    const n = activeConfig.bundles.length;
    const totalContent = n * itemWidth + (n - 1) * ITEM_GAP;
    const maxScroll = Math.max(0, totalContent - tw.offsetWidth);
    const st = Math.min(carouselPosition * step, maxScroll);
    tw.scrollTo({ left: st, behavior: animate ? "smooth" : "auto" });
    pb.disabled = carouselPosition === 0;
    nb.disabled = carouselPosition >= max;
    const dots = c.querySelectorAll(".halo-bundle-carousel__dot");
    dots.forEach((d, i) => { const a = i === carouselPosition; d.classList.toggle("active", a); d.setAttribute("aria-current", a ? "true" : "false"); });
  }

  function updateAllCarousels(animate = true) { document.querySelectorAll(".halo-bundle-carousel").forEach((c) => updateCarousel(c, animate)); }

  function initializeCarousels() {
    document.querySelectorAll(".halo-bundle-carousel").forEach((carousel) => {
      const pb = carousel.querySelector(".halo-bundle-carousel__nav--prev");
      const nb = carousel.querySelector(".halo-bundle-carousel__nav--next");
      const items = carousel.querySelectorAll(".halo-bundle-carousel__item");
      const moreInfoBtns = carousel.querySelectorAll(".halo-bundle-carousel__more-info");
      const tw = carousel.querySelector(".halo-bundle-carousel__track-wrapper");
      updateDots(carousel);
      let scrollTimeout;
      if (tw) {
        tw.addEventListener("scroll", () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            if (tw.offsetWidth === 0) return;
            const itemWidth = getActualItemWidth(carousel);
            const step = itemWidth + ITEM_GAP;
            const max = getMaxPosition(carousel);
            const maxScrollActual = tw.scrollWidth - tw.offsetWidth;
            const np = tw.scrollLeft >= maxScrollActual - 2
              ? max
              : Math.min(Math.round(tw.scrollLeft / step), max);
            if (np !== carouselPosition && np >= 0) {
              carouselPosition = np;
              pb.disabled = carouselPosition === 0;
              nb.disabled = carouselPosition >= max;
              const dots = carousel.querySelectorAll(".halo-bundle-carousel__dot");
              dots.forEach((d, i) => { const a = i === carouselPosition; d.classList.toggle("active", a); d.setAttribute("aria-current", a ? "true" : "false"); });
              document.querySelectorAll(".halo-bundle-carousel").forEach((oc) => { if (oc !== carousel) updateCarousel(oc, false); });
            }
          }, 50);
        }, { passive: true });
      }
      items.forEach((item) => {
        item.addEventListener("click", function (e) { if (e.target.classList.contains("halo-bundle-carousel__more-info")) return; selectBundle(this.dataset.bundleId); });
        item.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); if (e.target.classList.contains("halo-bundle-carousel__more-info")) { openPopup(parseInt(e.target.dataset.bundleIndex, 10)); } else { selectBundle(this.dataset.bundleId); } } });
      });
      moreInfoBtns.forEach((btn) => { btn.addEventListener("click", function (e) { e.stopPropagation(); openPopup(parseInt(this.dataset.bundleIndex, 10)); }); });
      pb.addEventListener("click", (e) => { e.preventDefault(); if (carouselPosition > 0) { carouselPosition--; updateAllCarousels(); } });
      nb.addEventListener("click", (e) => { e.preventDefault(); const max = getMaxPosition(carousel); if (carouselPosition < max) { carouselPosition++; updateAllCarousels(); } });
      updateCarousel(carousel, false);
    });
  }

  function interceptMainAddToCart() {
    const forms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
    forms.forEach((form) => {
      if (form.dataset.haloIntercepted) return;
      form.dataset.haloIntercepted = "true";
      const submitBtns = form.querySelectorAll('[type="submit"], .product-form__submit, button[name="add"], .add-to-cart, .btn-addtocart');
      submitBtns.forEach((submitBtn) => {
        if (submitBtn.dataset.haloIntercepted) return;
        submitBtn.dataset.haloIntercepted = "true";
        submitBtn.addEventListener("click", function (e) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          const btn = this; const bundle = selectedBundle || activeConfig.bundles[0];
          btn.disabled = true; const prevText = btn.textContent; btn.textContent = "Adding...";
          addToCart(bundle).then(() => { btn.textContent = "Added!"; setTimeout(() => { btn.disabled = false; btn.textContent = prevText; openCartDrawer(); }, 800); }).catch(() => { btn.disabled = false; btn.textContent = prevText; alert("Failed to add to cart. Please try again."); });
        }, true);
      });
      form.addEventListener("submit", function (e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); const firstBtn = form.querySelector('[type="submit"], .product-form__submit, button[name="add"], .add-to-cart, .btn-addtocart'); if (firstBtn) firstBtn.click(); }, true);
    });
    document.querySelectorAll(".product-form__submit:not([data-halo-intercepted]), .add-to-cart:not([data-halo-intercepted]), [data-add-to-cart]:not([data-halo-intercepted])").forEach((btn) => {
      if (btn.closest("form[data-halo-intercepted]")) return;
      btn.dataset.haloIntercepted = "true";
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        const bundle = selectedBundle || activeConfig.bundles[0];
        btn.disabled = true; const prevText = btn.textContent; btn.textContent = "Adding...";
        addToCart(bundle).then(() => { btn.textContent = "Added!"; setTimeout(() => { btn.disabled = false; btn.textContent = prevText; openCartDrawer(); }, 800); }).catch(() => { btn.disabled = false; btn.textContent = prevText; alert("Failed to add to cart. Please try again."); });
      }, true);
    });
  }

  function injectCarousel() {
    const mc = document.querySelector("#chirpProductCtaMobile");
    const buyButtons = document.querySelector(".b-buy_buttons_mjUxD6");
    let injected = false;
    if (mc && !mc.querySelector(".halo-bundle-carousel")) { const d = document.createElement("div"); d.innerHTML = createCarouselHTML(); mc.insertBefore(d.firstElementChild, mc.firstChild); injected = true; }
    if (buyButtons && !document.querySelector(".halo-bundle-carousel-desktop-wrapper")) { const w = document.createElement("div"); w.className = "halo-bundle-carousel-desktop-wrapper"; w.style.paddingBottom = "20px"; w.innerHTML = createCarouselHTML(); buyButtons.parentNode.insertBefore(w, buyButtons); injected = true; }
    if (!injected) return;
    getMainProductVariantId();
    let rt;
    window.addEventListener("resize", () => { clearTimeout(rt); rt = setTimeout(() => { document.querySelectorAll(".halo-bundle-carousel").forEach((c) => { if (c.querySelector(".halo-bundle-carousel__track-wrapper")?.offsetWidth > 0) { updateDots(c); } }); updateAllCarousels(); }, 100); });
    initializeCarousels();
    selectedBundle = activeConfig.bundles[0];
    updatePrice(activeConfig.bundles[0]);
    interceptMainAddToCart();
    setTimeout(interceptMainAddToCart, 500);
    setTimeout(interceptMainAddToCart, 1500);
    const observer = new MutationObserver((mutations) => { let shouldReintercept = false; mutations.forEach((mutation) => { if (mutation.addedNodes.length > 0) { mutation.addedNodes.forEach((node) => { if (node.nodeType === 1 && node.matches && (node.matches('form[action*="/cart/add"]') || (node.querySelector && node.querySelector('form[action*="/cart/add"]')))) { shouldReintercept = true; } }); } }); if (shouldReintercept) setTimeout(interceptMainAddToCart, 100); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function activate(config) {
    if (window._chirp_22_activated) return;
    window._chirp_22_activated = true;
    activeConfig = config;
    injectStyles();
    if (window.location.pathname.includes(PRODUCT_HANDLE)) { setTimeout(injectCarousel, 100); }
  }

  window.activate_chirp_22v1 = function () { activate(BUNDLES_V1); };
  window.activate_chirp_22v2 = function () { activate(BUNDLES_V2); };
})();

// START [CHRP-29] Interest Free Messaging on PDP
(() => {
  console.log("init [CHRP-29]v1");

  // inject styles once
  if (!document.querySelector('#chrp-29-styles')) {
    const style = document.createElement('style');
    style.id = 'chrp-29-styles';
    style.textContent = `
      #my-tooltip, #my-tooltip-mobile { display: none; }
      #price-info-btn, #price-info-btn-mobile { text-decoration: none; cursor: auto; }
    `;
    document.head.appendChild(style);
  }

  function movePaymentTerms(tooltipId, productFormEl, wrapperClass) {
    if (document.querySelector('.' + wrapperClass)) return;
    const tooltip = document.querySelector(tooltipId);
    if (!tooltip) return;
    const source = tooltip.querySelector('.text-xs');
    if (!source) return;

    const wrapper = document.createElement('div');
    wrapper.className = wrapperClass;
    wrapper.style.cssText = 'margin: 12px 12px 0; color: #000;';
    wrapper.appendChild(source);
    productFormEl.insertAdjacentElement('afterend', wrapper);
  }

  observeSelector('product-form', el => {
    if (el.closest('#chirpProductCtaMobile')) {
      movePaymentTerms('#my-tooltip-mobile', el, 'chrp-29-terms-mobile');
    } else {
      movePaymentTerms('#my-tooltip', el, 'chrp-29-terms-desktop');
    }
  });
})();
// END [CHRP-29]
